"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.collectBulkEntries = exports.PROPOSAL_TRACKER_CONTENT_HEIGHT = exports.APPLY_ALL_LIST_NOT_DRAWN_MESSAGE = void 0;
exports.commentNotAddedReasonsStillHolding = commentNotAddedReasonsStillHolding;
exports.useApplyAllActionsPanel = exports.trackerCardsWithFailuresOf = exports.trackerCardsOf = exports.reverseSameAnchorParagraphInsertions = exports.pendingCollisionCardsOf = exports.conflictGroupsWithFailuresOf = void 0;
var _react = _interopRequireWildcard(require("react"));
var _zod = require("zod");
var _materialSymbols = require("@design/icons/material-symbols");
var _document = require("../../utils/document");
var _commentAnchors = require("../../utils/comment-anchors");
var _bulkApplyRunTimeline = require("../../utils/bulk-apply-run-timeline");
var _officeHost = require("../../utils/office-host");
var _liveReviewApply = require("../../utils/live-review-apply");
var _anchorTrackerRegistry = require("../../utils/anchor/anchor-tracker-registry");
var _commentReply = require("../../utils/comment-reply");
var _api = require("../../utils/api");
var _BulkApplyRunContext = require("../../context/BulkApplyRunContext");
var _redlineBulkApplyLocal = require("../../utils/redline-bulk-apply-local");
var _redlineInsertionSlot = require("../../utils/redline-insertion-slot");
var _redlinePayload = require("@common/utils/redline/wire/redline-payload");
var _collisionWording = require("@common/components/remedy/collision-wording");
var _cardCollisions = require("@common/utils/redline/text/card-collisions");
var _tableOperations = require("@common/utils/redline/table-operations");
var _redlineEngine = require("@common/utils/redline/redline-engine");
var _proposalEngineAccess = require("../../utils/proposal-engine-access");
var _redlineLandingReconciliation = require("../../utils/redline-landing-reconciliation");
var _redlineAppliedCards = require("../../utils/redline-applied-cards");
var _redlineLandingPageFacts = require("../../utils/redline-landing-page-facts");
var _redlineRowRemoved = require("../../utils/redline-row-removed");
var _WordDocumentContext = require("../../context/WordDocumentContext");
var _ProposalTracker = require("./proposal-tracker/ProposalTracker");
var _useFailedCardsNotShown = require("./proposal-tracker/use-failed-cards-not-shown");
var _TrackerResizeHandle = require("./proposal-tracker/TrackerResizeHandle");
var _trackerTypes = require("./proposal-tracker/tracker-types");
var _commentPairingStore = require("./proposal-tracker/comment-pairing-store");
var _DocumentPageContext = require("../../context/DocumentPageContext");
var _applyOutcome = require("@common/utils/applyOutcome");
var _paragraphGroups = require("./proposal-tracker/paragraph-groups");
var _cardContent = require("./proposal-card/card-content");
var _cardCommentSelections = require("./proposal-card/card-comment-selections");
var _cardKinds = require("./proposal-card/card-kinds");
var _redlineCardComments = require("../../utils/redline-card-comments");
var _commentTargetRecovery = require("./proposal-card/comment-target-recovery");
var _changeThroughoutSelections = require("./proposal-card/change-throughout-selections");
var _changeThroughoutRunOutcome = require("./proposal-card/change-throughout-run-outcome");
var _cardLiveProposal = require("./proposal-card/card-live-proposal");
var _ProposalEditsContext = require("../../context/ProposalEditsContext");
var _locateProposalCard = require("./proposal-card/locate-proposal-card");
var _AuthContext = require("../../context/AuthContext");
var _ooxmlRecovery = require("../../utils/ooxml-recovery");
var _useApplyRedline = require("../../hooks/use-apply-redline");
var _useLiveProposal = require("../../hooks/use-live-proposal");
var _useLocalCopySyncedByContent = require("../../hooks/use-local-copy-synced-by-content");
var _ReviewedDocumentContext = require("../../context/ReviewedDocumentContext");
var _appliedActions = require("@common/constants/appliedActions");
var _toast = require("../../utils/toast");
var _untrackedWriteGuard = require("../../utils/untracked-write-guard");
var _errors = require("../../utils/errors");
var _AnalyticsContext = require("../../context/AnalyticsContext");
var _CardsNotShownContext = require("../../context/CardsNotShownContext");
var _ChatContext = require("../../context/ChatContext");
var _sentryReporter = require("../../utils/sentry-reporter");
var _SectionBoundary = require("../SectionBoundary");
var _chat = require("../../types/chat");
var _commentToolResult = require("./comment-tool-result");
var _isStreamingJsonResult = require("@common/utils/isStreamingJsonResult");
var _hoverTooltip = require("@common/components/hover-tooltip");
var _RemedyActionPrimitives = require("@common/components/remedy/RemedyActionPrimitives");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t21 in e) "default" !== _t21 && {}.hasOwnProperty.call(e, _t21) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t21)) && (i.get || i.set) ? o(f, _t21, i) : f[_t21] = e[_t21]); return f; })(e, t); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var COMMENTS_NOT_ADDED_SOURCE = 'comments_not_added';
function commentNotAddedReasonsStillHolding(commentsNotAdded, page) {
  var pageReadsAParagraphBack = function pageReadsAParagraphBack(_ref) {
    var commentBookmarks = _ref.commentBookmarks,
      notAddedAtMs = _ref.notAddedAtMs;
    return page.completed && page.readStartedAtMs > notAddedAtMs && commentBookmarks.some(function (commentBookmark) {
      return page.presentBookmarks.has(commentBookmark);
    });
  };
  return new Map(Array.from(commentsNotAdded).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      commentNotAdded = _ref3[1];
    return !pageReadsAParagraphBack(commentNotAdded);
  }).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      actionId = _ref5[0],
      commentNotAdded = _ref5[1];
    return [actionId, commentNotAdded.reason];
  }));
}
var PROPOSAL_TRACKER_CONTENT_HEIGHT = exports.PROPOSAL_TRACKER_CONTENT_HEIGHT = 380;
var addParagraphMessageContentSchema = _zod.z.object({
  after_bookmarks: _zod.z.array(_zod.z.string()).min(1)
});
var BATCH_REDLINE_CARD_TOOL_NAMES = ["redline_section", "edit_table", "change_throughout", "add_paragraph"];
function isBatchRedlineCardTool(toolName) {
  return BATCH_REDLINE_CARD_TOOL_NAMES.some(function (batchRedlineCardToolName) {
    return batchRedlineCardToolName === toolName;
  });
}
var redlineToolResultSchema = _zod.z.object({
  ooxml: _zod.z.union([_zod.z.string(), _zod.z.array(_zod.z.string())]).optional(),
  // Proposal engine only: a text card's tool result carries `redline` and no `ooxml`; a markup card's has no `redline` key.
  redline: _redlinePayload.redlineTextProposalSchema.optional(),
  // Proposal engine only: what the card was asked with, which is why it was proposed.
  regenerate_context: _zod.z.object({
    instructions: _zod.z.string(),
    context: _zod.z.string()
  }).optional(),
  bookmarks: _zod.z.array(_zod.z.string()).optional(),
  after_bookmarks: _zod.z.array(_zod.z.string()).optional(),
  comments: _redlinePayload.cardCommentsSchema
});

/** Why a chat card was proposed: its instructions and context, for the edit model when the card contests another's words. Empty for a markup card. */
var intentOf = function intentOf(regenerateContext) {
  return regenerateContext === undefined ? "" : [regenerateContext.instructions, regenerateContext.context].filter(function (part) {
    return part.length > 0;
  }).join("\n\n");
};
var CARD_LABEL_CHARACTERS = 40;
var cardLabelOf = function cardLabelOf(textRedline, actionDescription) {
  var _textRedline$paragrap, _textRedline$paragrap2;
  var editedParagraphText = (_textRedline$paragrap = textRedline === null || textRedline === void 0 || (_textRedline$paragrap2 = textRedline.paragraphs[0]) === null || _textRedline$paragrap2 === void 0 ? void 0 : _textRedline$paragrap2.textWhenProposed.trim()) !== null && _textRedline$paragrap !== void 0 ? _textRedline$paragrap : "";
  if (editedParagraphText.length === 0) return actionDescription;
  return editedParagraphText.length > CARD_LABEL_CHARACTERS ? "".concat(editedParagraphText.slice(0, CARD_LABEL_CHARACTERS), "\u2026") : editedParagraphText;
};
var commentToolResultSchema = _zod.z.object({
  text: _zod.z.string(),
  bookmarks: _zod.z.array(_zod.z.string()).optional(),
  placement: _zod.z.enum(["first_word", "span", "after_paragraph"]).nullish(),
  anchor_text: _zod.z.string().nullish()
});
var BULK_APPLY_FAILED_REASON = "We could not apply this change during bulk apply. Please regenerate it.";
var ANOTHER_RUN_IN_FLIGHT_MESSAGE = "Another Apply All is still running. Wait for it to finish, then try again.";
var appliesOnItsOwnBesideAPipelineRun = function appliesOnItsOwnBesideAPipelineRun(remedy, toolName) {
  return remedy.target_texts !== null && ((0, _redlinePayload.carriesTableOperations)(remedy.target_texts.tableChanges) || toolName === "add_paragraph");
};
var withoutCardsAppliedOnTheirOwn = function withoutCardsAppliedOnTheirOwn(bulk, messageMap) {
  var ownApplyActionIds = new Set(bulk.remedies.filter(function (remedy) {
    var _messageMap$get;
    return appliesOnItsOwnBesideAPipelineRun(remedy, (_messageMap$get = messageMap.get(remedy.rule_uuid)) === null || _messageMap$get === void 0 ? void 0 : _messageMap$get.toolName);
  }).map(function (remedy) {
    return remedy.rule_uuid;
  }));
  return {
    remedies: bulk.remedies.filter(function (remedy) {
      return !ownApplyActionIds.has(remedy.rule_uuid);
    }),
    comments: bulk.comments,
    actionIds: new Set(_toConsumableArray(bulk.actionIds).filter(function (actionId) {
      return !ownApplyActionIds.has(actionId);
    }))
  };
};
var placeLabelOf = function placeLabelOf(placeText, textBefore, textAfter) {
  return "".concat(textBefore).concat(placeText).concat(textAfter).trim();
};
var withEachCheckedPlaceAsAnEntry = function withEachCheckedPlaceAsAnEntry(bulk, messageMap) {
  var placeRulesByCardId = new Map();
  var remedies = bulk.remedies.flatMap(function (remedy) {
    var message = messageMap.get(remedy.rule_uuid);
    if (message === undefined || message.toolName !== 'change_throughout') return [remedy];
    var changeThroughoutSelection = (0, _changeThroughoutSelections.changeThroughoutSelectionOfToolContent)(remedy.rule_uuid, message.content);
    if (changeThroughoutSelection === null) return [remedy];
    var placeEntries = (0, _changeThroughoutSelections.placeEntriesOfSelection)(remedy.rule_uuid, changeThroughoutSelection);
    placeRulesByCardId.set(remedy.rule_uuid, placeEntries.map(function (placeEntry) {
      return {
        ruleId: placeEntry.ruleId,
        matchId: placeEntry.place.match_id
      };
    }));
    return placeEntries.map(function (placeEntry) {
      return _objectSpread(_objectSpread({}, remedy), {}, {
        rule_uuid: placeEntry.ruleId,
        rule_name: "".concat(remedy.rule_name, " \xB7 ").concat(placeLabelOf(placeEntry.place.text, placeEntry.place.text_before, placeEntry.place.text_after)),
        target_bookmark_names: [placeEntry.place.paragraph_id],
        target_texts: placeEntry.textRedline
      });
    });
  });
  return _objectSpread(_objectSpread({}, bulk), {}, {
    remedies: remedies,
    placeRulesByCardId: placeRulesByCardId
  });
};
var NO_COMMENTS_HELD_AFTER_THE_RUN = new Map();
var commentsHeldAfterTheRunOf = function commentsHeldAfterTheRunOf(heldComments, runIsLocal) {
  if (runIsLocal) return NO_COMMENTS_HELD_AFTER_THE_RUN;
  return heldComments;
};
var withCommentsWaitingForTheirRedlines = function withCommentsWaitingForTheirRedlines(bulk, heldComments) {
  return _objectSpread(_objectSpread({}, bulk), {}, {
    comments: bulk.comments.map(function (comment) {
      var redlineId = heldComments.get(comment.rule_uuid);
      return redlineId === undefined ? comment : _objectSpread(_objectSpread({}, comment), {}, {
        waits_for_rule_uuid: redlineId
      });
    })
  });
};
var cardCommentRuleIdOf = function cardCommentRuleIdOf(cardId, cardComment) {
  var _cardCommentKeyOf;
  return (_cardCommentKeyOf = (0, _cardCommentSelections.cardCommentKeyOf)(cardId, cardComment)) !== null && _cardCommentKeyOf !== void 0 ? _cardCommentKeyOf : "".concat(cardId, "#comment_").concat(cardComment.bookmark, ":").concat(cardComment.text);
};
var cardCommentsRidingTheRunOf = function cardCommentsRidingTheRunOf(bulkActionIds, actions, messageMap) {
  return actions.flatMap(function (action) {
    var message = messageMap.get(action.id);
    if (!bulkActionIds.has(action.id) || message === undefined) return [];
    return _cardCommentSelections.cardCommentSelections.checkedCommentsOf(action.id, (0, _cardContent.cardCommentsOfToolContent)(message.content)).map(function (cardComment) {
      return {
        cardId: action.id,
        cardNumber: action.cardNumber,
        cardComment: cardComment,
        ruleId: cardCommentRuleIdOf(action.id, cardComment)
      };
    });
  });
};
var withCardCommentsRidingTheRun = function withCardCommentsRidingTheRun(bulk, cardCommentsRidingTheRun) {
  var cardComments = cardCommentsRidingTheRun.map(function (_ref6) {
    var cardId = _ref6.cardId,
      cardNumber = _ref6.cardNumber,
      cardComment = _ref6.cardComment,
      ruleId = _ref6.ruleId;
    return {
      rule_uuid: ruleId,
      rule_name: "#".concat(cardNumber, " \xB7 ").concat(_cardKinds.PROPOSAL_CARD_KIND_LABELS.comment),
      bookmark: cardComment.bookmark,
      text: cardComment.text,
      placement: cardComment.placement,
      anchor_text: cardComment.anchor_text,
      waits_for_rule_uuid: cardId
    };
  });
  return _objectSpread(_objectSpread({}, bulk), {}, {
    comments: [].concat(_toConsumableArray(bulk.comments), _toConsumableArray(cardComments))
  });
};
var recordPlaceOutcomes = function recordPlaceOutcomes(placeOutcomesByCardId, messageMap) {
  var _iterator = _createForOfIteratorHelper(placeOutcomesByCardId),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        cardId = _step$value[0],
        placeOutcomes = _step$value[1];
      var message = messageMap.get(cardId);
      if (message === undefined) continue;
      var changeThroughoutCard = (0, _changeThroughoutSelections.changeThroughoutCardOfToolContent)(message.content);
      if (changeThroughoutCard === null) continue;
      _changeThroughoutSelections.changeThroughoutSelections.recordPlaceOutcomes(cardId, changeThroughoutCard, placeOutcomes);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var heldCommentsOf = function heldCommentsOf(actionsToRun, trackerCards, conflictGroups, documentPage) {
  var runnableIds = new Set(actionsToRun.filter(function (action) {
    return action.isSelected && !action.isApplied && !action.isPartiallyApplied;
  }).map(function (action) {
    return action.id;
  }));
  var heldCommentIdToRedlineId = new Map();
  var _iterator2 = _createForOfIteratorHelper((0, _paragraphGroups.paragraphGroupsOf)(actionsToRun, trackerCards, conflictGroups, documentPage)),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var grouped = _step2.value;
      var pairingKey = (0, _paragraphGroups.commentPairingKeyOf)(grouped);
      var group = pairingKey === null ? grouped : (0, _paragraphGroups.withCommentPairings)(grouped, _commentPairingStore.commentPairings.answerFor(pairingKey));
      var _iterator3 = _createForOfIteratorHelper((0, _paragraphGroups.allMembersOf)(group)),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var member = _step3.value;
          if (member.matchedRedlineId !== null && runnableIds.has(member.action.id) && runnableIds.has(member.matchedRedlineId)) {
            heldCommentIdToRedlineId.set(member.action.id, member.matchedRedlineId);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return heldCommentIdToRedlineId;
};
var commentsHeldBeforeTheClickOf = function commentsHeldBeforeTheClickOf(actions, messageMap, remedies) {
  var heldCommentIdToRedlineId = new Map();
  var _iterator4 = _createForOfIteratorHelper(actions),
    _step4;
  try {
    var _loop = function _loop() {
        var _parsed$data$bookmark;
        var action = _step4.value;
        if (action.type !== 'comment' || action.isApplied || action.isDismissed || action.heldBackReason !== _commentTargetRecovery.COMMENT_PARAGRAPH_GONE_MESSAGE) return 0; // continue
        var message = messageMap.get(action.id);
        if (message === undefined || message.toolName !== 'add_comment') return 0; // continue
        var raw;
        try {
          raw = JSON.parse(message.content);
        } catch (_unused) {
          return 0; // continue
        }
        var parsed = commentToolResultSchema.safeParse(raw);
        var bookmarks = parsed.success ? (_parsed$data$bookmark = parsed.data.bookmarks) !== null && _parsed$data$bookmark !== void 0 ? _parsed$data$bookmark : message.bookmarks : undefined;
        if (bookmarks === undefined || bookmarks.length === 0) return 0; // continue
        var redlineOfItsParagraph = remedies.find(function (remedy) {
          return bookmarks.every(function (bookmark) {
            return remedy.target_bookmark_names.includes(bookmark);
          });
        });
        if (redlineOfItsParagraph !== undefined) heldCommentIdToRedlineId.set(action.id, redlineOfItsParagraph.rule_uuid);
      },
      _ret;
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      _ret = _loop();
      if (_ret === 0) continue;
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return heldCommentIdToRedlineId;
};
var batchApplicableMessageMapOf = function batchApplicableMessageMapOf(messages) {
  var messageMap = new Map();
  messages.forEach(function (msg, index) {
    if ((0, _chat.isBatchApplicableActionMessage)(msg)) messageMap.set((0, _chat.getActionIdentifier)(msg, "msg-".concat(index)), msg);
  });
  return messageMap;
};
var pendingCollisionCardsOf = exports.pendingCollisionCardsOf = function pendingCollisionCardsOf(actions, messages) {
  var pendingActions = actions.filter(function (action) {
    return !action.isApplied && !action.isDismissed;
  }).map(function (action) {
    return _objectSpread(_objectSpread({}, action), {}, {
      isSelected: true
    });
  });
  return collectBulkEntries(pendingActions, batchApplicableMessageMapOf(messages)).remedies.flatMap(function (remedy) {
    return remedy.target_texts === null ? [] : [{
      cardId: remedy.rule_uuid,
      paragraphs: (0, _cardCollisions.collisionParagraphsOf)(remedy.target_texts)
    }];
  });
};
var contentReadingTheCheckedPlaces = function contentReadingTheCheckedPlaces(content, changeThroughoutSelection) {
  if (changeThroughoutSelection === null) return content;
  if (content.kind !== 'redline' && content.kind !== 'table') return content;
  return _objectSpread(_objectSpread({}, content), {}, {
    textRedline: changeThroughoutSelection.proposal
  });
};
var APPLY_ALL_LIST_NOT_DRAWN_MESSAGE = exports.APPLY_ALL_LIST_NOT_DRAWN_MESSAGE = 'The Apply All list could not be drawn.';
var trackerCardsWithFailuresOf = exports.trackerCardsWithFailuresOf = function trackerCardsWithFailuresOf(actions, messages, edits) {
  var messageOf = batchApplicableMessageMapOf(messages);
  var cardsThatThrew = [];
  var trackerCards = new Map(actions.flatMap(function (action) {
    try {
      var _action$supersededBy;
      var message = messageOf.get(action.id);
      var content = message === undefined ? null : (0, _cardContent.proposalCardContentOf)(message.toolName, message.content, message.bookmarks);
      if (message === undefined || content === null) return [];
      var edit = edits.get(action.id);
      var textRedlineBeforeEdit = (edit === null || edit === void 0 ? void 0 : edit.kind) === 'redline' ? edit.textRedlineBeforeEdit : null;
      var textRedlineWhenOpened = (edit === null || edit === void 0 ? void 0 : edit.kind) === "redline" ? edit.textRedlineWhenOpened : null;
      var textBeforeEdit = (edit === null || edit === void 0 ? void 0 : edit.kind) === 'comment' ? edit.textBeforeEdit : null;
      var changeThroughoutSelection = (0, _changeThroughoutSelections.changeThroughoutSelectionOfToolContent)(action.id, message.content);
      var trackerCard = {
        actionId: action.id,
        cardNumber: action.cardNumber,
        isApplied: action.isApplied,
        supersededBy: (_action$supersededBy = action.supersededBy) !== null && _action$supersededBy !== void 0 ? _action$supersededBy : null,
        textRedlineBeforeEdit: textRedlineBeforeEdit,
        textRedlineWhenOpened: textRedlineWhenOpened,
        textBeforeEdit: textBeforeEdit,
        content: contentReadingTheCheckedPlaces(content, changeThroughoutSelection),
        changeThroughoutSelection: changeThroughoutSelection
      };
      return [[action.id, trackerCard]];
    } catch (error) {
      cardsThatThrew.push({
        actionId: action.id,
        error: error
      });
      return [];
    }
  }));
  return {
    trackerCards: trackerCards,
    cardsThatThrew: cardsThatThrew
  };
};
var trackerCardsOf = exports.trackerCardsOf = function trackerCardsOf(actions, messages, edits) {
  return trackerCardsWithFailuresOf(actions, messages, edits).trackerCards;
};
var conflictGroupsWithFailuresOf = exports.conflictGroupsWithFailuresOf = function conflictGroupsWithFailuresOf(actions, trackerCards) {
  var cardsThatThrew = [];
  var textCardsOnPage = actions.filter(function (action) {
    return !action.isDismissed && !(action.isApplied && action.isRemovedFromConflictGroups);
  }).flatMap(function (action) {
    try {
      var card = trackerCards.get(action.id);
      var textRedline = card === undefined ? null : (0, _trackerTypes.textRedlineOfTrackerCard)(card);
      return card !== undefined && textRedline !== null && (card.content.kind === 'redline' || card.content.kind === 'table') ? [{
        cardId: card.actionId,
        paragraphs: (0, _cardCollisions.collisionParagraphsOf)(textRedline)
      }] : [];
    } catch (error) {
      cardsThatThrew.push({
        actionId: action.id,
        error: error
      });
      return [];
    }
  });
  var pendingIds = new Set(actions.filter(function (action) {
    return !action.isApplied && !action.isDismissed;
  }).map(function (action) {
    return action.id;
  }));
  try {
    var conflictGroups = (0, _cardCollisions.conflictGroupsOfCards)(textCardsOnPage).filter(function (group) {
      return group.cardIds.some(function (cardId) {
        return pendingIds.has(cardId);
      });
    }).map(function (group) {
      return {
        group: group,
        cards: group.cardIds.flatMap(function (cardId) {
          var card = trackerCards.get(cardId);
          return card ? [card] : [];
        })
      };
    });
    return {
      conflictGroups: conflictGroups,
      cardsThatThrew: cardsThatThrew,
      groupStepFailure: null
    };
  } catch (error) {
    return {
      conflictGroups: [],
      cardsThatThrew: cardsThatThrew,
      groupStepFailure: {
        error: error
      }
    };
  }
};
var collectBulkEntries = exports.collectBulkEntries = function collectBulkEntries(actions, messageMap) {
  var remedies = [];
  var comments = [];
  var actionIds = new Set();
  var _iterator5 = _createForOfIteratorHelper(actions),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var action = _step5.value;
      if (action.isApplied || !action.isSelected || action.isPartiallyApplied) continue;
      var message = messageMap.get(action.id);
      if (!message || (0, _commentToolResult.isKnownNonJsonToolResult)(message.content) || (0, _isStreamingJsonResult.isStreamingJsonResult)(message.content)) continue;
      var raw = void 0;
      try {
        raw = JSON.parse(message.content);
      } catch (_unused2) {
        continue;
      }
      var toolName = message.toolName;
      if (isBatchRedlineCardTool(toolName)) {
        var _parsed$data$bookmark2;
        var parsed = redlineToolResultSchema.safeParse(raw);
        if (!parsed.success) continue;
        var ooxmls = (Array.isArray(parsed.data.ooxml) ? parsed.data.ooxml : [parsed.data.ooxml]).filter(function (entry) {
          return typeof entry === "string" && entry.length > 0;
        });
        var bookmarks = toolName === "add_paragraph" ? parsed.data.after_bookmarks : (_parsed$data$bookmark2 = parsed.data.bookmarks) !== null && _parsed$data$bookmark2 !== void 0 ? _parsed$data$bookmark2 : parsed.data.after_bookmarks;
        var changeThroughoutSelection = (0, _changeThroughoutSelections.changeThroughoutSelectionOfToolContent)(action.id, message.content);
        if ((0, _changeThroughoutSelections.checksNoPlace)(changeThroughoutSelection)) continue;
        var textRedline = (0, _changeThroughoutSelections.textRedlineOfCardSelection)(changeThroughoutSelection, message.content);
        if (toolName === "add_paragraph" && textRedline === null) continue;
        if (ooxmls.length === 0 && textRedline === null || !bookmarks || bookmarks.length === 0) continue;
        remedies.push({
          rule_uuid: action.id,
          rule_name: "#".concat(action.cardNumber, " \xB7 ").concat(cardLabelOf(textRedline, action.description)),
          target_bookmark_names: bookmarks,
          target_ooxml_after: ooxmls,
          target_texts: textRedline,
          intent: intentOf(parsed.data.regenerate_context)
        });
        actionIds.add(action.id);
      } else if (toolName === "add_comment") {
        var _parsed$data$bookmark3, _parsed$data$placemen, _parsed$data$anchor_t;
        var _parsed = commentToolResultSchema.safeParse(raw);
        var _bookmarks = _parsed.success ? (_parsed$data$bookmark3 = _parsed.data.bookmarks) !== null && _parsed$data$bookmark3 !== void 0 ? _parsed$data$bookmark3 : message.bookmarks : undefined;
        if (!_parsed.success || !_bookmarks || _bookmarks.length === 0) continue;
        comments.push({
          rule_uuid: action.id,
          rule_name: action.description,
          bookmark: _bookmarks[0],
          text: _parsed.data.text,
          placement: (_parsed$data$placemen = _parsed.data.placement) !== null && _parsed$data$placemen !== void 0 ? _parsed$data$placemen : null,
          anchor_text: (_parsed$data$anchor_t = _parsed.data.anchor_text) !== null && _parsed$data$anchor_t !== void 0 ? _parsed$data$anchor_t : null
        });
        actionIds.add(action.id);
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  return {
    remedies: remedies,
    comments: comments,
    actionIds: actionIds
  };
};
var paragraphCardAnchorOf = function paragraphCardAnchorOf(message) {
  if (!message || message.toolName !== "add_paragraph") return null;
  try {
    var parsedContent = addParagraphMessageContentSchema.safeParse(JSON.parse(message.content));
    return parsedContent.success ? parsedContent.data.after_bookmarks[0] : null;
  } catch (_unused3) {
    return null;
  }
};
var reverseSameAnchorParagraphInsertions = exports.reverseSameAnchorParagraphInsertions = function reverseSameAnchorParagraphInsertions(actions, messageMap) {
  var groupPositions = new Map();
  actions.forEach(function (action, index) {
    var _groupPositions$get;
    if (action.isApplied || !action.isSelected) return;
    var message = messageMap.get(action.id);
    if (!message || message.toolName !== "add_paragraph") return;
    var rawContent;
    try {
      rawContent = JSON.parse(message.content);
    } catch (_unused4) {
      return;
    }
    var parsedContent = addParagraphMessageContentSchema.safeParse(rawContent);
    if (!parsedContent.success) return;
    var key = JSON.stringify(parsedContent.data.after_bookmarks);
    var positions = (_groupPositions$get = groupPositions.get(key)) !== null && _groupPositions$get !== void 0 ? _groupPositions$get : [];
    positions.push(index);
    groupPositions.set(key, positions);
  });
  var reordered = _toConsumableArray(actions);
  groupPositions.forEach(function (positions) {
    var reversedActions = positions.map(function (position) {
      return actions[position];
    }).reverse();
    positions.forEach(function (position, i) {
      reordered[position] = reversedActions[i];
    });
  });
  return reordered;
};
var rowDeletionCardOf = function rowDeletionCardOf(conflict, decision) {
  if (decision.kind !== 'card') return null;
  var card = conflict.cards.find(function (candidate) {
    return candidate.actionId === decision.cardId;
  });
  var textRedline = card === undefined ? null : (0, _trackerTypes.textRedlineOfTrackerCard)(card);
  return textRedline !== null && textRedline.tableChanges.rowDeletions.length > 0 ? textRedline : null;
};
var rowDeletionKeptEverywhereOf = function rowDeletionKeptEverywhereOf(conflict, decisions) {
  var first = decisions.length === 0 ? null : rowDeletionCardOf(conflict, decisions[0]);
  return first !== null && decisions.every(function (decision) {
    return rowDeletionCardOf(conflict, decision) === first;
  }) ? first : null;
};
var supersessionLabelOf = function supersessionLabelOf(conflict, decisions, appliedIds, authorName) {
  var keptCardNumbers = conflict.cards.filter(function (card) {
    return appliedIds.has(card.actionId) && decisions.some(function (decision) {
      return decision.kind === 'card' && decision.cardId === card.actionId;
    });
  }).map(function (card) {
    return card.cardNumber;
  });
  if (keptCardNumbers.length > 0) return (0, _collisionWording.joinedCardNumbersOf)(keptCardNumbers);
  if (decisions.every(function (decision) {
    return decision.kind === 'original';
  })) return 'the original words';
  return authorName ? "".concat(authorName, "'s edits") : 'your edits';
};
var decisionsOfZonesLostBy = function decisionsOfZonesLostBy(conflict, decisions, cardId) {
  return conflict.group.openZoneIndexes.flatMap(function (zoneIndex, position) {
    var decision = decisions[position];
    var zoneHoldsTheCard = conflict.group.zoning.zones[zoneIndex].options.some(function (option) {
      return option.cardId === cardId;
    });
    var cardWonTheZone = (decision === null || decision === void 0 ? void 0 : decision.kind) === 'card' && decision.cardId === cardId;
    return decision !== undefined && zoneHoldsTheCard && !cardWonTheZone ? [decision] : [];
  });
};
var cardLandsBesideItsLostZones = function cardLandsBesideItsLostZones(conflict, decisions, cardId) {
  var wonAnOpenZone = decisions.some(function (decision) {
    return decision.kind === 'card' && decision.cardId === cardId;
  });
  var writesAnUncontestedChange = conflict.group.zoning.uncontestedChanges.some(function (uncontested) {
    return uncontested.cardId === cardId;
  });
  var holdsASettledZone = conflict.group.zoning.zones.some(function (zone, zoneIndex) {
    return !conflict.group.openZoneIndexes.includes(zoneIndex) && zone.options.some(function (option) {
      return option.cardId === cardId;
    });
  });
  return wonAnOpenZone || writesAnUncontestedChange || holdsASettledZone;
};
var resolvedCardOutcomeOf = function resolvedCardOutcomeOf(conflict, decisions, cardId) {
  if (decisionsOfZonesLostBy(conflict, decisions, cardId).length === 0) return 'keptWhole';
  return cardLandsBesideItsLostZones(conflict, decisions, cardId) ? 'keptInPart' : 'notKept';
};
var useApplyAllActionsPanel = exports.useApplyAllActionsPanel = function useApplyAllActionsPanel(_ref7) {
  var actions = _ref7.actions,
    messages = _ref7.messages,
    conversationId = _ref7.conversationId,
    maxTrackerHeight = _ref7.maxTrackerHeight,
    onActionApplied = _ref7.onActionApplied,
    onActionClick = _ref7.onActionClick,
    onToggleSelection = _ref7.onToggleSelection,
    onToggleSelectAll = _ref7.onToggleSelectAll,
    onActionDismissed = _ref7.onActionDismissed,
    onActionUndismissed = _ref7.onActionUndismissed,
    onActionRefused = _ref7.onActionRefused,
    onActionFailed = _ref7.onActionFailed,
    onActionSuperseded = _ref7.onActionSuperseded,
    onActionPartlySuperseded = _ref7.onActionPartlySuperseded,
    onActionRemovedFromConflictGroups = _ref7.onActionRemovedFromConflictGroups,
    insertionPlaceOf = _ref7.insertionPlaceOf;
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    authorName = _useAuthInfo.authorName;
  var liveProposalRegistry = (0, _useLiveProposal.useLiveProposalRegistry)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isApplying = _useState2[0],
    setIsApplying = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDismissing = _useState4[0],
    setIsDismissing = _useState4[1];
  var _useLocalCopySyncedBy = (0, _useLocalCopySyncedByContent.useLocalCopySyncedByContent)(actions),
    _useLocalCopySyncedBy2 = _slicedToArray(_useLocalCopySyncedBy, 2),
    localActions = _useLocalCopySyncedBy2[0],
    setLocalActions = _useLocalCopySyncedBy2[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    repairingActionId = _useState6[0],
    setRepairingActionId = _useState6[1];
  var _useBulkApplyRun = (0, _BulkApplyRunContext.useBulkApplyRun)(),
    startRun = _useBulkApplyRun.startRun,
    isAnyBulkRunActive = _useBulkApplyRun.isRunning;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    analytics = _useAnalytics.analytics,
    sendError = _useAnalytics.sendError,
    sendMessage = _useAnalytics.sendMessage;
  var _useChat = (0, _ChatContext.useChat)(),
    markActionWithRecoveryWarning = _useChat.markActionWithRecoveryWarning,
    getActionRecoveryWarning = _useChat.getActionRecoveryWarning,
    recordActionFailure = _useChat.recordActionFailure,
    isActionDismissalSaving = _useChat.isActionDismissalSaving;
  var applyRedline = (0, _useApplyRedline.useApplyRedlineOrFail)();
  var _useReviewedDocument = (0, _ReviewedDocumentContext.useReviewedDocument)(),
    currentReviewId = _useReviewedDocument.currentReviewId;
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var authHeaderRef = (0, _react.useRef)(authHeader);
  authHeaderRef.current = authHeader;
  var _useWordDocument = (0, _WordDocumentContext.useWordDocument)(),
    selectBookmarksRangeIfPresent = _useWordDocument.selectBookmarksRangeIfPresent;
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showsProposalEngineTracker = _useState8[0],
    setShowsProposalEngineTracker = _useState8[1];
  var _useState9 = (0, _react.useState)(PROPOSAL_TRACKER_CONTENT_HEIGHT),
    _useState0 = _slicedToArray(_useState9, 2),
    trackerHeight = _useState0[0],
    setTrackerHeight = _useState0[1];
  var shownTrackerHeight = Math.min(trackerHeight, maxTrackerHeight);
  (0, _react.useEffect)(function () {
    var cancelled = false;
    void _proposalEngineAccess.ProposalEngineAccess.current().then(function (access) {
      if (!cancelled) setShowsProposalEngineTracker(access.enabled);
    });
    return function () {
      cancelled = true;
    };
  }, []);
  var _useProposalEdits = (0, _ProposalEditsContext.useProposalEdits)(),
    editsOf = _useProposalEdits.editsOf,
    requestEdit = _useProposalEdits.requestEdit;
  var proposalEdits = editsOf(conversationId);
  var changeThroughoutSelectionsVersion = (0, _changeThroughoutSelections.useChangeThroughoutSelectionsVersion)();
  var _useMemo = (0, _react.useMemo)(function () {
      return trackerCardsWithFailuresOf(localActions, messages, proposalEdits);
    }, [localActions, messages, proposalEdits, changeThroughoutSelectionsVersion]),
    trackerCards = _useMemo.trackerCards,
    trackerCardsThatThrew = _useMemo.cardsThatThrew;
  (0, _react.useEffect)(function () {
    if (!showsProposalEngineTracker) return;
    trackerCards.forEach(function (trackerCard, actionId) {
      if (trackerCard.content.kind !== 'comment') return;
      try {
        _anchorTrackerRegistry.anchorTrackers.trackerFor(trackerCard.content.bookmarks, (0, _locateProposalCard.redlineLocatingProposalCard)(trackerCard.content));
      } catch (error) {
        (0, _sentryReporter.reportError)(error, {
          extra: {
            component: 'ApplyAllActionsPanel',
            action: 'attach_comment_card',
            actionId: actionId
          }
        });
      }
    });
  }, [trackerCards, showsProposalEngineTracker]);
  var documentPage = (0, _DocumentPageContext.useDocumentPage)();
  var _useState1 = (0, _react.useState)(new Map()),
    _useState10 = _slicedToArray(_useState1, 2),
    commentsNotAddedByActionId = _useState10[0],
    setCommentsNotAddedByActionId = _useState10[1];
  var commentNotAddedReasonByActionId = (0, _react.useMemo)(function () {
    return commentNotAddedReasonsStillHolding(commentsNotAddedByActionId, documentPage);
  }, [commentsNotAddedByActionId, documentPage]);
  (0, _useFailedCardsNotShown.useFailedCardsNotShown)(commentNotAddedReasonByActionId, COMMENTS_NOT_ADDED_SOURCE);
  var readDocumentPageAgain = (0, _DocumentPageContext.useReadDocumentPageAgain)();
  var handleEditCard = (0, _react.useCallback)(function (actionId) {
    onActionClick === null || onActionClick === void 0 || onActionClick(actionId);
    requestEdit(actionId);
  }, [onActionClick, requestEdit]);
  var _useMemo2 = (0, _react.useMemo)(function () {
      return conflictGroupsWithFailuresOf(localActions, trackerCards);
    }, [localActions, trackerCards]),
    conflictGroups = _useMemo2.conflictGroups,
    conflictCardsThatThrew = _useMemo2.cardsThatThrew,
    groupStepFailure = _useMemo2.groupStepFailure;
  var groupStepFailureRef = (0, _react.useRef)(groupStepFailure);
  groupStepFailureRef.current = groupStepFailure;
  var conflictGroupStepFailed = groupStepFailure !== null;
  (0, _react.useEffect)(function () {
    if (!conflictGroupStepFailed || groupStepFailureRef.current === null) return;
    (0, _sentryReporter.reportError)(groupStepFailureRef.current.error, {
      extra: {
        component: 'ApplyAllActionsPanel',
        action: 'conflict_groups'
      }
    });
  }, [conflictGroupStepFailed]);
  var _useCardsNotShown = (0, _CardsNotShownContext.useCardsNotShown)('apply_all_cards'),
    markNotShown = _useCardsNotShown.markNotShown;
  var cardsThatThrew = (0, _react.useMemo)(function () {
    return [].concat(_toConsumableArray(trackerCardsThatThrew), _toConsumableArray(conflictCardsThatThrew));
  }, [trackerCardsThatThrew, conflictCardsThatThrew]);
  var cardsThatThrewRef = (0, _react.useRef)(cardsThatThrew);
  cardsThatThrewRef.current = cardsThatThrew;
  var cardsThatThrewKey = Array.from(new Set(cardsThatThrew.map(function (card) {
    return card.actionId;
  }))).join("\0");
  (0, _react.useEffect)(function () {
    if (cardsThatThrewKey === '') return undefined;
    var _iterator6 = _createForOfIteratorHelper(cardsThatThrewRef.current),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var card = _step6.value;
        (0, _sentryReporter.reportError)(card.error, {
          extra: {
            component: 'ApplyAllActionsPanel',
            action: 'tracker_card',
            actionId: card.actionId
          }
        });
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
    var idsNotShown = cardsThatThrewKey.split("\0");
    markNotShown(idsNotShown, _SectionBoundary.CARD_NOT_SHOWN_REASON);
    return function () {
      return markNotShown(idsNotShown, null);
    };
  }, [cardsThatThrewKey, markNotShown]);
  var handleGoTo = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(bookmarks, actionIds) {
      var cardAtThePlace;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            cardAtThePlace = actionIds.map(function (actionId) {
              return trackerCards.get(actionId);
            }).find(function (card) {
              return card !== undefined;
            });
            _context.n = 1;
            return (0, _locateProposalCard.goToDocumentPlace)(bookmarks, cardAtThePlace === undefined ? null : (0, _locateProposalCard.redlineLocatingProposalCard)(cardAtThePlace.content), selectBookmarksRangeIfPresent);
          case 1:
            analytics === null || analytics === void 0 || analytics.track('proposal_tracker_location_shown', {
              conversationId: conversationId,
              actionIds: actionIds
            });
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref8.apply(this, arguments);
    };
  }(), [trackerCards, selectBookmarksRangeIfPresent, analytics, conversationId]);
  var handleLocateCard = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(card) {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return (0, _locateProposalCard.locateProposalCard)(card.content, selectBookmarksRangeIfPresent, function (anchorBookmark) {
              return insertionPlaceOf(card.actionId, anchorBookmark);
            });
          case 1:
            analytics === null || analytics === void 0 || analytics.track('proposal_tracker_location_shown', {
              conversationId: conversationId,
              actionIds: [card.actionId]
            });
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x3) {
      return _ref9.apply(this, arguments);
    };
  }(), [selectBookmarksRangeIfPresent, insertionPlaceOf, analytics, conversationId]);
  var handleResolveOpened = (0, _react.useCallback)(function (conflict) {
    analytics === null || analytics === void 0 || analytics.track('proposal_tracker_conflict_opened', {
      conversationId: conversationId,
      actionIds: conflict.cards.map(function (card) {
        return card.actionId;
      }),
      zoneCount: conflict.group.openZoneIndexes.length
    });
  }, [analytics, conversationId]);
  var freezeAppliedLooks = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(cards) {
      var _access$authorName;
      var access, signedInAuthorName, _iterator7, _step7, card, request;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return _proposalEngineAccess.ProposalEngineAccess.current().catch(function () {
              return null;
            });
          case 1:
            access = _context3.v;
            if (!(access === null || !access.signedIn)) {
              _context3.n = 2;
              break;
            }
            return _context3.a(2);
          case 2:
            signedInAuthorName = (_access$authorName = access.authorName) !== null && _access$authorName !== void 0 ? _access$authorName : _redlineEngine.DIOPTRA_AUTHOR;
            _iterator7 = _createForOfIteratorHelper(cards);
            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                card = _step7.value;
                request = (0, _cardLiveProposal.liveProposalRequestOfCard)(card.content, card.textRedlineBeforeEdit, card.textRedlineWhenOpened, signedInAuthorName);
                if (request !== null) liveProposalRegistry.freezeAppliedLook(request);
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
          case 3:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x4) {
      return _ref0.apply(this, arguments);
    };
  }(), [liveProposalRegistry]);
  var markCardCommentRelocated = (0, _react.useCallback)(function (cardId, relocatedCardComment) {
    var relocationWarning = (0, _redlineCardComments.recoveryWarningOfRelocatedCardComment)(cardId, relocatedCardComment);
    markActionWithRecoveryWarning(conversationId, relocationWarning.actionId, relocationWarning.warning);
  }, [markActionWithRecoveryWarning, conversationId]);
  var writeCommentsOfLandedCards = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(landedCardIds, messageOf) {
      var _iterator8, _step8, _loop2, _t2;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            _iterator8 = _createForOfIteratorHelper(landedCardIds);
            _context5.p = 1;
            _loop2 = /*#__PURE__*/_regenerator().m(function _loop2() {
              var actionId, message, cardComments, reason, _t;
              return _regenerator().w(function (_context4) {
                while (1) switch (_context4.p = _context4.n) {
                  case 0:
                    actionId = _step8.value;
                    _context4.p = 1;
                    message = messageOf(actionId);
                    cardComments = message === undefined ? [] : _cardCommentSelections.cardCommentSelections.checkedCommentsOf(actionId, (0, _cardContent.cardCommentsOfToolContent)(message.content));
                    if (!(message === undefined || cardComments.length === 0)) {
                      _context4.n = 2;
                      break;
                    }
                    return _context4.a(2, 1);
                  case 2:
                    _context4.n = 3;
                    return (0, _redlineCardComments.writeCardComments)(actionId, cardComments, (0, _cardContent.textRedlineOfToolContent)(message.content), function (relocatedCardComment) {
                      return markCardCommentRelocated(actionId, relocatedCardComment);
                    }, sendError);
                  case 3:
                    _context4.n = 5;
                    break;
                  case 4:
                    _context4.p = 4;
                    _t = _context4.v;
                    (0, _toast.toastError)(_t);
                    reason = (0, _errors.userMessageOf)(_t);
                    setLocalActions(function (prev) {
                      return prev.map(function (a) {
                        return a.id === actionId ? _objectSpread(_objectSpread({}, a), {}, {
                          failureReason: reason,
                          isPartiallyApplied: true,
                          isSelected: false
                        }) : a;
                      });
                    });
                    onActionFailed(actionId, {
                      reason: reason,
                      isPartiallyApplied: true,
                      conflictingActionIds: []
                    });
                  case 5:
                    return _context4.a(2);
                }
              }, _loop2, null, [[1, 4]]);
            });
            _iterator8.s();
          case 2:
            if ((_step8 = _iterator8.n()).done) {
              _context5.n = 5;
              break;
            }
            return _context5.d(_regeneratorValues(_loop2()), 3);
          case 3:
            if (!_context5.v) {
              _context5.n = 4;
              break;
            }
            return _context5.a(3, 4);
          case 4:
            _context5.n = 2;
            break;
          case 5:
            _context5.n = 7;
            break;
          case 6:
            _context5.p = 6;
            _t2 = _context5.v;
            _iterator8.e(_t2);
          case 7:
            _context5.p = 7;
            _iterator8.f();
            return _context5.f(7);
          case 8:
            return _context5.a(2);
        }
      }, _callee4, null, [[1, 6, 7, 8]]);
    }));
    return function (_x5, _x6) {
      return _ref1.apply(this, arguments);
    };
  }(), [sendError, setLocalActions, onActionFailed, markCardCommentRelocated]);
  var applyConflictResolution = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(conflict, composedText, decisions) {
      var _conflict$cards$map$f, _conflict$cards$map$f2, _rowDeletionKeptEvery;
      var author, resolution, appliedBefore, outcomeOf, idsResolvedAs, appliedIds, partlyKeptIds, landedIds, supersededIds, labelOfZonesLostBy, messageOfCard, landingTargets, _t3;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            author = (_conflict$cards$map$f = (_conflict$cards$map$f2 = conflict.cards.map(_trackerTypes.textRedlineOfTrackerCard).find(function (textRedline) {
              return textRedline !== null;
            })) === null || _conflict$cards$map$f2 === void 0 ? void 0 : _conflict$cards$map$f2.author) !== null && _conflict$cards$map$f !== void 0 ? _conflict$cards$map$f : '';
            resolution = (_rowDeletionKeptEvery = rowDeletionKeptEverywhereOf(conflict, decisions)) !== null && _rowDeletionKeptEvery !== void 0 ? _rowDeletionKeptEvery : {
              author: author,
              paragraphs: [{
                bookmark: conflict.group.bookmark,
                textWhenProposed: conflict.group.baseText,
                textProposed: composedText
              }],
              insertions: [],
              tableChanges: _tableOperations.NO_TABLE_CHANGES,
              cardKind: 'paragraphs',
              reverts: []
            };
            setIsApplying(true);
            _context6.p = 1;
            _context6.n = 2;
            return freezeAppliedLooks(conflict.cards);
          case 2:
            _context6.n = 3;
            return applyRedline({
              ooxml: '',
              textRedline: resolution,
              cardComments: [],
              actionId: null,
              initiatedFrom: 'chat_apply_all',
              bookmarks: [conflict.group.bookmark],
              insertAfter: false
            });
          case 3:
            appliedBefore = new Set(localActions.filter(function (action) {
              return action.isApplied;
            }).map(function (action) {
              return action.id;
            }));
            outcomeOf = new Map(conflict.cards.map(function (card) {
              return [card.actionId, resolvedCardOutcomeOf(conflict, decisions, card.actionId)];
            }));
            idsResolvedAs = function idsResolvedAs(outcome) {
              return new Set(Array.from(outcomeOf).filter(function (_ref11) {
                var _ref12 = _slicedToArray(_ref11, 2),
                  cardOutcome = _ref12[1];
                return cardOutcome === outcome;
              }).map(function (_ref13) {
                var _ref14 = _slicedToArray(_ref13, 1),
                  actionId = _ref14[0];
                return actionId;
              }));
            };
            appliedIds = idsResolvedAs('keptWhole');
            partlyKeptIds = idsResolvedAs('keptInPart');
            landedIds = new Set([].concat(_toConsumableArray(appliedIds), _toConsumableArray(partlyKeptIds)));
            supersededIds = new Set(Array.from(idsResolvedAs('notKept')).filter(function (actionId) {
              return appliedBefore.has(actionId);
            }));
            labelOfZonesLostBy = function labelOfZonesLostBy(actionId) {
              return supersessionLabelOf(conflict, decisionsOfZonesLostBy(conflict, decisions, actionId), landedIds, authorName);
            };
            setLocalActions(function (prev) {
              return prev.map(function (action) {
                if (appliedIds.has(action.id)) return _objectSpread(_objectSpread({}, action), {}, {
                  isApplied: true,
                  isRefused: false,
                  failureReason: undefined,
                  supersededBy: undefined
                });
                if (partlyKeptIds.has(action.id)) return _objectSpread(_objectSpread({}, action), {}, {
                  isApplied: true,
                  isRefused: false,
                  failureReason: undefined,
                  partSupersededBy: labelOfZonesLostBy(action.id)
                });
                if (supersededIds.has(action.id)) return _objectSpread(_objectSpread({}, action), {}, {
                  supersededBy: labelOfZonesLostBy(action.id)
                });
                return action;
              });
            });
            appliedIds.forEach(function (actionId) {
              return onActionApplied(actionId);
            });
            partlyKeptIds.forEach(function (actionId) {
              onActionApplied(actionId);
              onActionPartlySuperseded === null || onActionPartlySuperseded === void 0 || onActionPartlySuperseded(actionId, labelOfZonesLostBy(actionId));
            });
            messageOfCard = batchApplicableMessageMapOf(messages);
            _context6.n = 4;
            return writeCommentsOfLandedCards(landedIds, function (actionId) {
              return messageOfCard.get(actionId);
            });
          case 4:
            supersededIds.forEach(function (actionId) {
              return onActionSuperseded(actionId, labelOfZonesLostBy(actionId));
            });
            (0, _redlineAppliedCards.tellAgentsCardsApplied)(conflict.cards.filter(function (card) {
              return landedIds.has(card.actionId);
            }).map(function (card) {
              return (0, _redlineAppliedCards.appliedEditReportOf)((0, _redlineAppliedCards.attemptedEditOf)(card.actionId, (0, _locateProposalCard.bookmarksLocatingProposalCard)(card.content), (0, _trackerTypes.textRedlineOfTrackerCard)(card)), partlyKeptIds.has(card.actionId));
            }));
            landingTargets = conflict.cards.filter(function (card) {
              return appliedIds.has(card.actionId);
            }).flatMap(function (card) {
              var textRedline = (0, _trackerTypes.textRedlineOfTrackerCard)(card);
              return textRedline === null ? [] : [{
                kind: 'text_card',
                ruleId: card.actionId,
                bookmarkNames: (0, _locateProposalCard.bookmarksLocatingProposalCard)(card.content),
                card: textRedline,
                insertsAfterBookmarks: false
              }];
            });
            void (0, _redlineLandingReconciliation.auditCardLandings)(landingTargets, _redlineLandingPageFacts.readLandingPageFacts).then(function (verdicts) {
              return (0, _redlineLandingReconciliation.logLandingMismatches)(verdicts, landingTargets);
            }).catch(function (auditError) {
              sendError(auditError instanceof Error ? auditError : new Error(String(auditError)), {
                component: 'ProposalTracker',
                action: 'audit_conflict_resolution',
                conversationId: conversationId
              });
            });
            analytics === null || analytics === void 0 || analytics.track('proposal_tracker_conflict_resolved', {
              conversationId: conversationId,
              actionIds: conflict.cards.map(function (card) {
                return card.actionId;
              }),
              appliedActionIds: Array.from(appliedIds),
              customZoneCount: decisions.filter(function (decision) {
                return decision.kind === 'custom';
              }).length,
              originalZoneCount: decisions.filter(function (decision) {
                return decision.kind === 'original';
              }).length
            });
            _context6.n = 6;
            break;
          case 5:
            _context6.p = 5;
            _t3 = _context6.v;
            (0, _toast.toastError)(_t3);
            sendError(_t3 instanceof Error ? _t3 : new Error(String(_t3)), {
              component: 'ProposalTracker',
              action: 'apply_conflict_resolution',
              conversationId: conversationId
            });
          case 6:
            _context6.p = 6;
            setIsApplying(false);
            return _context6.f(6);
          case 7:
            return _context6.a(2);
        }
      }, _callee5, null, [[1, 5, 6, 7]]);
    }));
    return function (_x7, _x8, _x9) {
      return _ref10.apply(this, arguments);
    };
  }(), [applyRedline, freezeAppliedLooks, writeCommentsOfLandedCards, messages, analytics, conversationId, localActions, setLocalActions, authorName, onActionApplied, onActionSuperseded, onActionPartlySuperseded, sendError]);
  var actionsWithDismissalSaving = (0, _react.useMemo)(function () {
    return localActions.map(function (action) {
      return _objectSpread(_objectSpread({}, action), {}, {
        isDismissalSaving: isActionDismissalSaving(conversationId, action.id)
      });
    });
  }, [localActions, isActionDismissalSaving, conversationId]);
  var unappliedUndismissedActions = actionsWithDismissalSaving.filter(function (a) {
    return !a.isApplied && !a.isDismissed;
  });
  var dismissedActions = actionsWithDismissalSaving.filter(function (a) {
    return a.isDismissed;
  });
  var selectableActions = unappliedUndismissedActions.filter(function (a) {
    return !a.documentAlreadyReadsAsProposed && a.heldBackReason === undefined;
  });
  var allUnappliedSelected = selectableActions.length > 0 && selectableActions.every(function (a) {
    return a.isSelected;
  });
  var someUnappliedSelected = unappliedUndismissedActions.some(function (a) {
    return a.isSelected;
  });
  var allApplied = localActions.every(function (action) {
    return action.isApplied || action.isDismissed;
  });
  var parseToolResult = (0, _react.useCallback)(function (message, schema) {
    if ((0, _commentToolResult.isKnownNonJsonToolResult)(message.content) || (0, _isStreamingJsonResult.isStreamingJsonResult)(message.content)) return null;
    var raw;
    try {
      raw = JSON.parse(message.content);
    } catch (_unused5) {
      raw = null;
    }
    var parsed = schema.safeParse(raw);
    if (!parsed.success) {
      sendMessage('ApplyAllActionsPanel: skipped action — tool result did not match the expected shape', 'warning');
      throw new _errors.UserFacingError("We could not read this proposed change. Please regenerate it.");
    }
    return parsed.data;
  }, [sendMessage]);
  var applyAction = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(action, message) {
      var toolName, _toolMessageContent$b, toolMessageContent, ooxmls, bookmarks, changeThroughoutSelection, heldBackReason, textRedline, insertAfter, onStatus, writesIntoRemovedRow, labelTheRowWrittenInto, ooxmlsInApplyOrder, landed, _iterator9, _step9, ooxml, _commentData$bookmark, _commentData$anchor_t3, commentData, _bookmarks2, commentContent, parsedReply, unhandledToolName, _t4, _t5, _t6;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            toolName = message.toolName;
            if (!isBatchRedlineCardTool(toolName)) {
              _context9.n = 19;
              break;
            }
            toolMessageContent = parseToolResult(message, redlineToolResultSchema);
            if (toolMessageContent) {
              _context9.n = 1;
              break;
            }
            return _context9.a(2, false);
          case 1:
            ooxmls = (Array.isArray(toolMessageContent.ooxml) ? toolMessageContent.ooxml : [toolMessageContent.ooxml]).filter(function (entry) {
              return typeof entry === "string" && entry.length > 0;
            });
            bookmarks = toolName === "add_paragraph" ? toolMessageContent.after_bookmarks : (_toolMessageContent$b = toolMessageContent.bookmarks) !== null && _toolMessageContent$b !== void 0 ? _toolMessageContent$b : toolMessageContent.after_bookmarks;
            changeThroughoutSelection = (0, _changeThroughoutSelections.changeThroughoutSelectionOfToolContent)(action.id, message.content);
            heldBackReason = (0, _changeThroughoutSelections.heldBackReasonOfSelection)(changeThroughoutSelection);
            if (!(heldBackReason !== null)) {
              _context9.n = 2;
              break;
            }
            throw new _errors.UserFacingError(heldBackReason);
          case 2:
            textRedline = (0, _changeThroughoutSelections.textRedlineOfCardSelection)(changeThroughoutSelection, message.content);
            if (!(ooxmls.length === 0 && textRedline === null || !(bookmarks !== null && bookmarks !== void 0 && bookmarks.length))) {
              _context9.n = 3;
              break;
            }
            throw new _errors.ApplyFailureError("We cannot tell where this change belongs in the document. Please regenerate it.", _appliedActions.APPLY_FAILURE_LOCATION_NOT_FOUND);
          case 3:
            insertAfter = toolName === "add_paragraph";
            onStatus = function onStatus(status) {
              setRepairingActionId(status === 'in_progress' ? action.id : null);
              if (status === 'warning') {
                markActionWithRecoveryWarning(conversationId, action.id, _ooxmlRecovery.RECOVERY_USED_MESSAGE);
              }
            };
            _context9.n = 4;
            return (0, _redlineRowRemoved.removedRowKeysOfBookmarksInDocument)(bookmarks);
          case 4:
            _t4 = _context9.v.size;
            writesIntoRemovedRow = _t4 > 0;
            labelTheRowWrittenInto = function labelTheRowWrittenInto() {
              return setLocalActions(function (prev) {
                return prev.map(function (a) {
                  var _a$rowRemovedBy;
                  return a.id === action.id ? _objectSpread(_objectSpread({}, a), {}, {
                    rowRemovedBy: writesIntoRemovedRow ? (_a$rowRemovedBy = a.rowRemovedBy) !== null && _a$rowRemovedBy !== void 0 ? _a$rowRemovedBy : _redlineRowRemoved.ROW_REMOVED_BY_A_PENDING_CHANGE : undefined
                  }) : a;
                });
              });
            };
            if (!(ooxmls.length === 0)) {
              _context9.n = 6;
              break;
            }
            _context9.n = 5;
            return applyRedline({
              ooxml: "",
              textRedline: textRedline,
              cardComments: _cardCommentSelections.cardCommentSelections.checkedCommentsOf(action.id, toolMessageContent.comments),
              actionId: action.id,
              initiatedFrom: 'chat_apply_all',
              bookmarks: bookmarks,
              insertAfter: false,
              onStatus: onStatus,
              onCommentRelocated: function onCommentRelocated(relocatedCardComment) {
                return markCardCommentRelocated(action.id, relocatedCardComment);
              }
            });
          case 5:
            labelTheRowWrittenInto();
            return _context9.a(2, true);
          case 6:
            ooxmlsInApplyOrder = insertAfter ? _toConsumableArray(ooxmls).reverse() : ooxmls;
            landed = 0;
            _iterator9 = _createForOfIteratorHelper(ooxmlsInApplyOrder);
            _context9.p = 7;
            _iterator9.s();
          case 8:
            if ((_step9 = _iterator9.n()).done) {
              _context9.n = 15;
              break;
            }
            ooxml = _step9.value;
            _context9.p = 9;
            _context9.n = 10;
            return applyRedline({
              ooxml: ooxml,
              textRedline: null,
              cardComments: [],
              actionId: action.id,
              initiatedFrom: 'chat_apply_all',
              bookmarks: bookmarks,
              insertAfter: insertAfter,
              onStatus: onStatus
            });
          case 10:
            _context9.n = 13;
            break;
          case 11:
            _context9.p = 11;
            _t5 = _context9.v;
            if (!((_t5 instanceof _untrackedWriteGuard.UntrackedWriteRefused || _t5 instanceof _errors.ApplyFailureError || _t5 instanceof _errors.PartialRedlineApply) && landed === 0)) {
              _context9.n = 12;
              break;
            }
            throw _t5;
          case 12:
            throw new _errors.PartialRedlineApply(landed, ooxmls.length, _t5 instanceof Error ? _t5 : new Error(String(_t5)));
          case 13:
            landed++;
          case 14:
            _context9.n = 8;
            break;
          case 15:
            _context9.n = 17;
            break;
          case 16:
            _context9.p = 16;
            _t6 = _context9.v;
            _iterator9.e(_t6);
          case 17:
            _context9.p = 17;
            _iterator9.f();
            return _context9.f(17);
          case 18:
            labelTheRowWrittenInto();
            return _context9.a(2, true);
          case 19:
            if (!(toolName === "add_comment")) {
              _context9.n = 23;
              break;
            }
            commentData = parseToolResult(message, commentToolResultSchema);
            if (commentData) {
              _context9.n = 20;
              break;
            }
            return _context9.a(2, false);
          case 20:
            _bookmarks2 = (_commentData$bookmark = commentData.bookmarks) !== null && _commentData$bookmark !== void 0 ? _commentData$bookmark : message.bookmarks;
            if (!(!_bookmarks2 || _bookmarks2.length === 0)) {
              _context9.n = 21;
              break;
            }
            throw new _errors.ApplyFailureError("We cannot tell where this comment belongs in the document. Please regenerate it.", _appliedActions.APPLY_FAILURE_LOCATION_NOT_FOUND);
          case 21:
            commentContent = (0, _cardContent.proposalCardContentOf)(toolName, message.content, message.bookmarks);
            _context9.n = 22;
            return (0, _document.withWordContextWrite)(/*#__PURE__*/function () {
              var _ref16 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(context) {
                var _commentData$placemen, _commentData$anchor_t, _commentData$anchor_t2;
                var range, relocation;
                return _regenerator().w(function (_context7) {
                  while (1) switch (_context7.n) {
                    case 0:
                      if (!((commentContent === null || commentContent === void 0 ? void 0 : commentContent.kind) === 'comment')) {
                        _context7.n = 1;
                        break;
                      }
                      _context7.n = 1;
                      return (0, _commentTargetRecovery.recoverCommentTargetWithin)(context, commentContent);
                    case 1:
                      _context7.n = 2;
                      return (0, _document.getExpandedRangeForBookmarks)(context, _bookmarks2);
                    case 2:
                      range = _context7.v;
                      if (range) {
                        _context7.n = 3;
                        break;
                      }
                      throw new _errors.ApplyFailureError("We cannot find where to apply this. Changes may have altered the location after the comment was generated.", _appliedActions.APPLY_FAILURE_LOCATION_NOT_FOUND);
                    case 3:
                      _context7.n = 4;
                      return (0, _document.writeReviewComment)(context, {
                        bookmarkedRange: range,
                        placement: (_commentData$placemen = commentData.placement) !== null && _commentData$placemen !== void 0 ? _commentData$placemen : null,
                        anchorText: (_commentData$anchor_t = commentData.anchor_text) !== null && _commentData$anchor_t !== void 0 ? _commentData$anchor_t : null
                      }, commentData.text);
                    case 4:
                      relocation = _context7.v;
                      if (relocation !== null) markActionWithRecoveryWarning(conversationId, action.id, (0, _commentAnchors.relocatedCommentSentenceOf)(relocation, (_commentData$anchor_t2 = commentData.anchor_text) !== null && _commentData$anchor_t2 !== void 0 ? _commentData$anchor_t2 : null));
                    case 5:
                      return _context7.a(2);
                  }
                }, _callee6);
              }));
              return function (_x10) {
                return _ref16.apply(this, arguments);
              };
            }());
          case 22:
            (0, _redlineAppliedCards.tellAgentsCardsApplied)([(0, _redlineAppliedCards.appliedCommentReportOf)({
              cardId: action.id,
              paragraphBookmarkNames: _bookmarks2,
              text: commentData.text,
              quotedText: (_commentData$anchor_t3 = commentData.anchor_text) !== null && _commentData$anchor_t3 !== void 0 ? _commentData$anchor_t3 : null
            })]);
            return _context9.a(2, true);
          case 23:
            if (!(toolName === "reply_to_comment")) {
              _context9.n = 27;
              break;
            }
            parsedReply = (0, _commentToolResult.parseReplyToolResult)(message.content);
            if (!(parsedReply.kind !== "reply")) {
              _context9.n = 25;
              break;
            }
            if (!(parsedReply.kind === "invalid")) {
              _context9.n = 24;
              break;
            }
            sendMessage('ApplyAllActionsPanel: skipped reply action — reply payload failed to parse', 'warning');
            throw new _errors.UserFacingError("We could not read this proposed reply. Please regenerate it.");
          case 24:
            return _context9.a(2, false);
          case 25:
            _context9.n = 26;
            return (0, _document.withWordContextWrite)(/*#__PURE__*/function () {
              var _ref17 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(context) {
                return _regenerator().w(function (_context8) {
                  while (1) switch (_context8.n) {
                    case 0:
                      _context8.n = 1;
                      return (0, _commentReply.applyCommentReply)(context, parsedReply.targetCommentId, parsedReply.text);
                    case 1:
                      return _context8.a(2);
                  }
                }, _callee7);
              }));
              return function (_x11) {
                return _ref17.apply(this, arguments);
              };
            }());
          case 26:
            (0, _redlineAppliedCards.tellAgentsCardsApplied)([(0, _redlineAppliedCards.appliedReplyCardOf)(action.id, parsedReply.targetCommentId, parsedReply.text)]);
            return _context9.a(2, true);
          case 27:
            unhandledToolName = toolName;
            throw new _errors.UserFacingError("Apply All cannot apply a \"".concat(unhandledToolName, "\" action."));
          case 28:
            return _context9.a(2);
        }
      }, _callee8, null, [[9, 11], [7, 16, 17, 18]]);
    }));
    return function (_x0, _x1) {
      return _ref15.apply(this, arguments);
    };
  }(), [applyRedline, conversationId, markActionWithRecoveryWarning, markCardCommentRelocated, parseToolResult, sendMessage, setLocalActions]);
  var trackBulkApplyCompleted = (0, _react.useCallback)(function (outcome, finalTimeline) {
    if (outcome.creditedRuleIds.length > 0) {
      analytics === null || analytics === void 0 || analytics.track("bulk_apply_completed", _objectSpread(_objectSpread({
        conversationId: conversationId,
        appliedActionIds: outcome.creditedRuleIds,
        failedActionIds: outcome.failedRules.map(function (rule) {
          return rule.ruleId;
        }),
        runKind: outcome.runKind,
        runDurationMs: outcome.runDurationMs,
        hostPlatform: (0, _officeHost.readOfficeHostPlatformOrUnknown)()
      }, outcome.mergeWrite), (0, _bulkApplyRunTimeline.bulkApplyTimelineProperties)(finalTimeline)));
    }
  }, [analytics, conversationId]);
  var settleBulkActionOutcomes = (0, _react.useCallback)(function (outcome, bulkIds, heldComments) {
    var succeeded = new Set(outcome.creditedRuleIds);
    var notChosen = new Set(outcome.notChosenRuleIds);
    var commentCardsHeldBack = new Set(outcome.commentOutcomes.filter(function (commentOutcome) {
      return commentOutcome.result === "heldBack" && heldComments.has(commentOutcome.ruleId) && !succeeded.has(commentOutcome.ruleId);
    }).map(function (commentOutcome) {
      return commentOutcome.ruleId;
    }));
    var notAddedReasonOf = new Map(outcome.commentOutcomes.filter(function (commentOutcome) {
      return commentOutcome.result === "heldBack" && commentOutcome.heldBackReason !== undefined && !succeeded.has(commentOutcome.ruleId);
    }).map(function (commentOutcome) {
      return [commentOutcome.ruleId, commentOutcome.heldBackReason];
    }));
    var cardNumberOfAction = new Map(localActions.map(function (action) {
      return [action.id, action.cardNumber];
    }));
    var droppedOf = new Map(outcome.droppedCards.map(function (dropped) {
      return [dropped.ruleId, dropped];
    }));
    /**
     * The credited cards the applier wrote in part, by rule: each says so on the card with the
     * applier's reason, is not selected again, and is never "Failed to apply" (the single Apply
     * path marks a partly applied card the same way).
     */
    var partiallyAppliedOf = new Map(outcome.partiallyAppliedCards.map(function (card) {
      return [card.ruleId, card];
    }));
    var failureReasonOf = function failureReasonOf(id) {
      var _ref18, _partiallyAppliedOf$g, _partiallyAppliedOf$g2, _droppedOf$get;
      return (_ref18 = (_partiallyAppliedOf$g = (_partiallyAppliedOf$g2 = partiallyAppliedOf.get(id)) === null || _partiallyAppliedOf$g2 === void 0 ? void 0 : _partiallyAppliedOf$g2.reason) !== null && _partiallyAppliedOf$g !== void 0 ? _partiallyAppliedOf$g : (_droppedOf$get = droppedOf.get(id)) === null || _droppedOf$get === void 0 ? void 0 : _droppedOf$get.reason) !== null && _ref18 !== void 0 ? _ref18 : BULK_APPLY_FAILED_REASON;
    };
    var cardNumberOf = new Map(localActions.map(function (action) {
      return [action.id, action.cardNumber];
    }));
    var keepersLabelOf = function keepersLabelOf(card) {
      var keepers = Array.from(new Set(card.conflictingRuleIds.map(function (ruleId) {
        return cardNumberOf.get(ruleId);
      }).filter(function (cardNumber) {
        return cardNumber !== undefined;
      })));
      return keepers.length === 0 ? _RemedyActionPrimitives.DOCUMENT_WORDS_SUPERSESSION : keepers.map(function (cardNumber) {
        return "#".concat(cardNumber);
      }).join(', ');
    };
    var supersededByOf = new Map(outcome.notChosenCards.map(function (card) {
      return [card.ruleId, keepersLabelOf(card)];
    }));
    var partSupersededByOf = new Map(outcome.partlySupersededCards.map(function (card) {
      return [card.ruleId, keepersLabelOf(card)];
    }));
    var notAddedAtMs = Date.now();
    setCommentsNotAddedByActionId(function (previous) {
      var next = new Map(previous);
      bulkIds.forEach(function (id) {
        return next.delete(id);
      });
      notAddedReasonOf.forEach(function (reason, id) {
        var card = trackerCards.get(id);
        if (bulkIds.has(id)) next.set(id, {
          reason: reason,
          commentBookmarks: card === undefined ? [] : (0, _locateProposalCard.bookmarksLocatingProposalCard)(card.content),
          notAddedAtMs: notAddedAtMs
        });
      });
      return next;
    });
    setLocalActions(function (prev) {
      return prev.map(function (a) {
        var _supersededByOf$get, _partiallyAppliedOf$g3, _partiallyAppliedOf$g4;
        if (bulkIds.has(a.id) && notAddedReasonOf.has(a.id)) return _objectSpread(_objectSpread({}, a), {}, {
          failureReason: undefined,
          isRefused: false
        });
        if (!bulkIds.has(a.id) || commentCardsHeldBack.has(a.id)) return a;
        if (notChosen.has(a.id)) return _objectSpread(_objectSpread({}, a), {}, {
          supersededBy: (_supersededByOf$get = supersededByOf.get(a.id)) !== null && _supersededByOf$get !== void 0 ? _supersededByOf$get : _RemedyActionPrimitives.DOCUMENT_WORDS_SUPERSESSION
        });
        if (partiallyAppliedOf.has(a.id)) return _objectSpread(_objectSpread({}, a), {}, {
          isApplied: ((_partiallyAppliedOf$g3 = partiallyAppliedOf.get(a.id)) === null || _partiallyAppliedOf$g3 === void 0 ? void 0 : _partiallyAppliedOf$g3.everyWriteLanded) === true,
          isRefused: false,
          failureReason: failureReasonOf(a.id),
          isPartiallyApplied: true,
          writtenBack: ((_partiallyAppliedOf$g4 = partiallyAppliedOf.get(a.id)) === null || _partiallyAppliedOf$g4 === void 0 ? void 0 : _partiallyAppliedOf$g4.writtenBack) === true,
          isSelected: false
        });
        return succeeded.has(a.id) ? _objectSpread(_objectSpread({}, a), {}, {
          isApplied: true,
          isRefused: false,
          failureReason: undefined,
          partSupersededBy: partSupersededByOf.get(a.id)
        }) : _objectSpread(_objectSpread({}, a), {}, {
          isRefused: false,
          failureReason: failureReasonOf(a.id)
        });
      });
    });
    bulkIds.forEach(function (id) {
      if (commentCardsHeldBack.has(id)) {
        var _cardNumberOfAction$g, _cardNumberOfAction$g2, _heldComments$get;
        (0, _toast.toastInfo)("Comment #".concat((_cardNumberOfAction$g = cardNumberOfAction.get(id)) !== null && _cardNumberOfAction$g !== void 0 ? _cardNumberOfAction$g : '?', " was held back because redline #").concat((_cardNumberOfAction$g2 = cardNumberOfAction.get((_heldComments$get = heldComments.get(id)) !== null && _heldComments$get !== void 0 ? _heldComments$get : '')) !== null && _cardNumberOfAction$g2 !== void 0 ? _cardNumberOfAction$g2 : '?', " was not applied."));
        return;
      }
      if (notAddedReasonOf.has(id)) return;
      if (notChosen.has(id)) {
        var _supersededByOf$get2;
        onActionSuperseded(id, (_supersededByOf$get2 = supersededByOf.get(id)) !== null && _supersededByOf$get2 !== void 0 ? _supersededByOf$get2 : _RemedyActionPrimitives.DOCUMENT_WORDS_SUPERSESSION);
        return;
      }
      var partlyApplied = partiallyAppliedOf.get(id);
      if (partlyApplied !== undefined) {
        if (partlyApplied.everyWriteLanded) onActionApplied(id);else recordActionFailure(conversationId, id, _appliedActions.APPLY_FAILURE_BULK_MERGE_FAILED);
        onActionFailed(id, {
          reason: failureReasonOf(id),
          isPartiallyApplied: true,
          conflictingActionIds: [],
          writtenBack: partlyApplied.writtenBack === true
        });
        return;
      }
      if (succeeded.has(id)) {
        onActionApplied(id);
        var partSupersededBy = partSupersededByOf.get(id);
        if (partSupersededBy !== undefined) onActionPartlySuperseded === null || onActionPartlySuperseded === void 0 || onActionPartlySuperseded(id, partSupersededBy);
      } else {
        var _droppedOf$get$confli, _droppedOf$get2;
        onActionFailed(id, {
          reason: failureReasonOf(id),
          isPartiallyApplied: outcome.partiallyAppliedRuleIds.includes(id),
          conflictingActionIds: (_droppedOf$get$confli = (_droppedOf$get2 = droppedOf.get(id)) === null || _droppedOf$get2 === void 0 ? void 0 : _droppedOf$get2.conflictingRuleIds) !== null && _droppedOf$get$confli !== void 0 ? _droppedOf$get$confli : []
        });
      }
    });
  }, [conversationId, localActions, trackerCards, setLocalActions, onActionApplied, onActionFailed, onActionSuperseded, onActionPartlySuperseded, recordActionFailure]);
  var markCardsWhoseCommentsWereNotWritten = (0, _react.useCallback)(function (outcome, runComments) {
    var credited = new Set(outcome.creditedRuleIds);
    var cardCommentOfRule = new Map(runComments.filter(function (comment) {
      return (0, _cardCommentSelections.isCardCommentKey)(comment.rule_uuid);
    }).map(function (comment) {
      return [comment.rule_uuid, comment];
    }));
    var notWrittenByCardId = new Map();
    var _iterator0 = _createForOfIteratorHelper(outcome.commentOutcomes),
      _step0;
    try {
      for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
        var _notWrittenByCardId$g;
        var commentOutcome = _step0.value;
        var cardComment = cardCommentOfRule.get(commentOutcome.ruleId);
        var cardId = cardComment === null || cardComment === void 0 ? void 0 : cardComment.waits_for_rule_uuid;
        if (commentOutcome.result === "written" || cardComment === undefined || cardId === undefined || !credited.has(cardId)) continue;
        notWrittenByCardId.set(cardId, [].concat(_toConsumableArray((_notWrittenByCardId$g = notWrittenByCardId.get(cardId)) !== null && _notWrittenByCardId$g !== void 0 ? _notWrittenByCardId$g : []), [{
          commentText: cardComment.text,
          paragraphGone: commentOutcome.result === "heldBack"
        }]));
      }
    } catch (err) {
      _iterator0.e(err);
    } finally {
      _iterator0.f();
    }
    var _iterator1 = _createForOfIteratorHelper(notWrittenByCardId),
      _step1;
    try {
      var _loop3 = function _loop3() {
        var _step1$value = _slicedToArray(_step1.value, 2),
          cardId = _step1$value[0],
          commentsNotWritten = _step1$value[1];
        var commentCount = Array.from(cardCommentOfRule.values()).filter(function (comment) {
          return comment.waits_for_rule_uuid === cardId;
        }).length;
        var reason = new _errors.CommentsNotWrittenRedlineApply(commentsNotWritten, commentCount).message;
        setLocalActions(function (prev) {
          return prev.map(function (a) {
            return a.id === cardId ? _objectSpread(_objectSpread({}, a), {}, {
              failureReason: reason,
              isPartiallyApplied: true,
              isSelected: false
            }) : a;
          });
        });
        onActionFailed(cardId, {
          reason: reason,
          isPartiallyApplied: true,
          conflictingActionIds: []
        });
      };
      for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
        _loop3();
      }
    } catch (err) {
      _iterator1.e(err);
    } finally {
      _iterator1.f();
    }
  }, [setLocalActions, onActionFailed]);
  var markCommentsTheRunRelocated = (0, _react.useCallback)(function (outcome, runComments, cardCommentsRidingTheRun) {
    var cardCommentRidingOfRule = new Map(cardCommentsRidingTheRun.map(function (cardCommentRiding) {
      return [cardCommentRiding.ruleId, cardCommentRiding];
    }));
    var runCommentOfRule = new Map(runComments.map(function (runComment) {
      return [runComment.rule_uuid, runComment];
    }));
    var _iterator10 = _createForOfIteratorHelper(outcome.commentOutcomes),
      _step10;
    try {
      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
        var _runCommentOfRule$get, _runCommentOfRule$get2;
        var commentOutcome = _step10.value;
        if (commentOutcome.result !== "written" || commentOutcome.relocation === null) continue;
        var cardCommentRiding = cardCommentRidingOfRule.get(commentOutcome.ruleId);
        if (cardCommentRiding !== undefined) {
          markCardCommentRelocated(cardCommentRiding.cardId, (0, _redlineCardComments.relocatedCardCommentOf)(cardCommentRiding.cardId, cardCommentRiding.cardComment, commentOutcome.relocation));
          continue;
        }
        markActionWithRecoveryWarning(conversationId, commentOutcome.ruleId, (0, _commentAnchors.relocatedCommentSentenceOf)(commentOutcome.relocation, (_runCommentOfRule$get = (_runCommentOfRule$get2 = runCommentOfRule.get(commentOutcome.ruleId)) === null || _runCommentOfRule$get2 === void 0 ? void 0 : _runCommentOfRule$get2.anchor_text) !== null && _runCommentOfRule$get !== void 0 ? _runCommentOfRule$get : null));
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }
  }, [markCardCommentRelocated, markActionWithRecoveryWarning, conversationId]);
  var applyHeldComments = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(heldComments, appliedRedlineIds, actionsToRun, messageMap) {
      var _iterator11, _step11, _loop4, _ret2, _t8;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.p = _context1.n) {
          case 0:
            _iterator11 = _createForOfIteratorHelper(heldComments);
            _context1.p = 1;
            _loop4 = /*#__PURE__*/_regenerator().m(function _loop4() {
              var _step11$value, commentId, redlineId, comment, message, _redline$cardNumber, redline, applied, _t7;
              return _regenerator().w(function (_context0) {
                while (1) switch (_context0.p = _context0.n) {
                  case 0:
                    _step11$value = _slicedToArray(_step11.value, 2), commentId = _step11$value[0], redlineId = _step11$value[1];
                    comment = actionsToRun.find(function (action) {
                      return action.id === commentId;
                    });
                    message = messageMap.get(commentId);
                    if (!(comment === undefined || message === undefined)) {
                      _context0.n = 1;
                      break;
                    }
                    return _context0.a(2, 0);
                  case 1:
                    if (appliedRedlineIds.has(redlineId)) {
                      _context0.n = 2;
                      break;
                    }
                    redline = actionsToRun.find(function (action) {
                      return action.id === redlineId;
                    });
                    (0, _toast.toastInfo)("Comment #".concat(comment.cardNumber, " was held back because redline #").concat((_redline$cardNumber = redline === null || redline === void 0 ? void 0 : redline.cardNumber) !== null && _redline$cardNumber !== void 0 ? _redline$cardNumber : '?', " was not applied."));
                    return _context0.a(2, 0);
                  case 2:
                    _context0.p = 2;
                    _context0.n = 3;
                    return applyAction(comment, message);
                  case 3:
                    applied = _context0.v;
                    if (applied) {
                      _context0.n = 4;
                      break;
                    }
                    return _context0.a(2, 0);
                  case 4:
                    onActionApplied(comment.id);
                    setLocalActions(function (prev) {
                      return prev.map(function (a) {
                        return a.id === comment.id ? _objectSpread(_objectSpread({}, a), {}, {
                          isApplied: true,
                          failureReason: undefined
                        }) : a;
                      });
                    });
                    _context0.n = 6;
                    break;
                  case 5:
                    _context0.p = 5;
                    _t7 = _context0.v;
                    (0, _toast.toastError)(_t7);
                    onActionFailed(comment.id, {
                      reason: (0, _errors.userMessageOf)(_t7),
                      isPartiallyApplied: false,
                      conflictingActionIds: []
                    });
                  case 6:
                    return _context0.a(2);
                }
              }, _loop4, null, [[2, 5]]);
            });
            _iterator11.s();
          case 2:
            if ((_step11 = _iterator11.n()).done) {
              _context1.n = 5;
              break;
            }
            return _context1.d(_regeneratorValues(_loop4()), 3);
          case 3:
            _ret2 = _context1.v;
            if (!(_ret2 === 0)) {
              _context1.n = 4;
              break;
            }
            return _context1.a(3, 4);
          case 4:
            _context1.n = 2;
            break;
          case 5:
            _context1.n = 7;
            break;
          case 6:
            _context1.p = 6;
            _t8 = _context1.v;
            _iterator11.e(_t8);
          case 7:
            _context1.p = 7;
            _iterator11.f();
            return _context1.f(7);
          case 8:
            return _context1.a(2);
        }
      }, _callee9, null, [[1, 6, 7, 8]]);
    }));
    return function (_x12, _x13, _x14, _x15) {
      return _ref19.apply(this, arguments);
    };
  }(), [applyAction, setLocalActions, onActionApplied, onActionFailed]);
  var applyActions = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(actionsToRun) {
      var bulkStarted, messageMap, heldComments, sequentiallyAppliedIds, markRedlineLanded, runIsLocal, commentsHeldAfterTheRun, actionsInChatOrder, orderedActions, bulkEntries, bulkOfCards, bulkOfPlaces, cardCommentsRidingTheRun, bulk, commentsHeldBeforeTheClick, releaseHeldComments, runsAsOneRun, showRunRule, applyOneByOne, appliedBeforeTheRun, runInsertionAnchors, _iterator12, _step12, action, paragraphCardAnchor, source, bulkActionIds, cardOutcomeOfTheRun, started, _iterator13, _step13, _action, _t0, _t1, _t10, _t11, _t12, _t13, _t14, _t15, _t16, _t17, _t18, _t19, _t20;
      return _regenerator().w(function (_context12) {
        while (1) switch (_context12.p = _context12.n) {
          case 0:
            setIsApplying(true);
            bulkStarted = false;
            _context12.p = 1;
            _context12.n = 2;
            return freezeAppliedLooks(actionsToRun.flatMap(function (action) {
              var card = trackerCards.get(action.id);
              return card === undefined ? [] : [card];
            }));
          case 2:
            messageMap = new Map();
            messages.forEach(function (msg, index) {
              if (!(0, _chat.isBatchApplicableActionMessage)(msg)) return;
              messageMap.set((0, _chat.getActionIdentifier)(msg, "msg-".concat(index)), msg);
            });
            heldComments = showsProposalEngineTracker ? heldCommentsOf(actionsToRun, trackerCards, conflictGroups, documentPage) : new Map();
            sequentiallyAppliedIds = new Set();
            markRedlineLanded = function markRedlineLanded(redlineId) {
              onActionApplied(redlineId);
              sequentiallyAppliedIds.add(redlineId);
            };
            runIsLocal = (0, _redlineBulkApplyLocal.everyRemedyCarriesTexts)(collectBulkEntries(actionsToRun, messageMap).remedies);
            commentsHeldAfterTheRun = commentsHeldAfterTheRunOf(heldComments, runIsLocal);
            actionsInChatOrder = actionsToRun.filter(function (action) {
              return !commentsHeldAfterTheRun.has(action.id);
            });
            orderedActions = reverseSameAnchorParagraphInsertions(actionsInChatOrder, messageMap);
            bulkEntries = authHeaderRef.current ? collectBulkEntries(actionsInChatOrder, messageMap) : {
              remedies: [],
              comments: [],
              actionIds: new Set()
            };
            bulkOfCards = runIsLocal ? withCommentsWaitingForTheirRedlines(bulkEntries, heldComments) : withoutCardsAppliedOnTheirOwn(bulkEntries, messageMap);
            bulkOfPlaces = withEachCheckedPlaceAsAnEntry(bulkOfCards, messageMap);
            cardCommentsRidingTheRun = runIsLocal ? cardCommentsRidingTheRunOf(bulkOfPlaces.actionIds, actionsInChatOrder, messageMap) : [];
            bulk = runIsLocal ? withCardCommentsRidingTheRun(bulkOfPlaces, cardCommentsRidingTheRun) : bulkOfPlaces;
            commentsHeldBeforeTheClick = commentsHeldBeforeTheClickOf(actionsToRun, messageMap, bulk.remedies);
            releaseHeldComments = function releaseHeldComments(appliedRedlineIds) {
              return applyHeldComments(new Map([].concat(_toConsumableArray(commentsHeldAfterTheRun), _toConsumableArray(commentsHeldBeforeTheClick))), appliedRedlineIds, actionsToRun, messageMap);
            };
            runsAsOneRun = bulk.actionIds.size > 1 || bulk.placeRulesByCardId.size > 0;
            showRunRule = function showRunRule(ruleId) {
              onActionClick === null || onActionClick === void 0 || onActionClick((0, _changeThroughoutRunOutcome.cardIdOfRunRule)(bulk.placeRulesByCardId, ruleId));
            };
            applyOneByOne = /*#__PURE__*/function () {
              var _ref21 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(action) {
                var message, applied, writtenBack, reason, isRefusal, partial, everyWriteLanded, _t9;
                return _regenerator().w(function (_context10) {
                  while (1) switch (_context10.p = _context10.n) {
                    case 0:
                      _context10.p = 0;
                      message = messageMap.get(action.id);
                      if (message) {
                        _context10.n = 1;
                        break;
                      }
                      sendError(new Error("Apply All could not resolve the message for a selected action"), {
                        component: "ApplyAllActionsPanel",
                        action: "resolve_action_message",
                        actionId: action.id
                      });
                      throw new _errors.UserFacingError("We lost track of this change. Please regenerate it.");
                    case 1:
                      _context10.n = 2;
                      return applyAction(action, message);
                    case 2:
                      applied = _context10.v;
                      if (applied) {
                        _context10.n = 3;
                        break;
                      }
                      return _context10.a(2);
                    case 3:
                      markRedlineLanded(action.id);
                      setLocalActions(function (prev) {
                        return prev.map(function (a) {
                          return a.id === action.id ? _objectSpread(_objectSpread({}, a), {}, {
                            isApplied: true,
                            failureReason: undefined
                          }) : a;
                        });
                      });
                      _context10.n = 6;
                      break;
                    case 4:
                      _context10.p = 4;
                      _t9 = _context10.v;
                      if (!(_t9 instanceof _applyOutcome.ApplyHeldBack)) {
                        _context10.n = 5;
                        break;
                      }
                      readDocumentPageAgain();
                      return _context10.a(2);
                    case 5:
                      writtenBack = _t9 instanceof _errors.WrittenBackRedlineApply;
                      if (!writtenBack) (0, _toast.toastError)(_t9);
                      reason = (0, _errors.userMessageOf)(_t9);
                      isRefusal = _t9 instanceof _untrackedWriteGuard.UntrackedWriteRefused;
                      partial = _t9 instanceof _errors.PartialRedlineApply;
                      everyWriteLanded = (0, _applyOutcome.everyWriteLandedIn)(_t9);
                      setLocalActions(function (prev) {
                        return prev.map(function (a) {
                          return a.id === action.id ? isRefusal ? _objectSpread(_objectSpread({}, a), {}, {
                            isRefused: true
                          }) : _objectSpread(_objectSpread({}, a), {}, {
                            isApplied: a.isApplied || everyWriteLanded,
                            isRefused: false,
                            failureReason: reason,
                            isPartiallyApplied: partial,
                            writtenBack: writtenBack,
                            isSelected: a.isSelected && !partial
                          }) : a;
                        });
                      });
                      if (isRefusal) {
                        onActionRefused(action.id, _t9.lost, _t9.added);
                      } else {
                        if (everyWriteLanded) markRedlineLanded(action.id);
                        onActionFailed(action.id, {
                          reason: reason,
                          isPartiallyApplied: partial,
                          conflictingActionIds: [],
                          writtenBack: writtenBack
                        });
                        if (!everyWriteLanded) recordActionFailure(conversationId, action.id, (0, _appliedActions.applyFailureReason)(_t9));
                      }
                      if ((!(_t9 instanceof _errors.UserFacingError) || partial) && !writtenBack) {
                        sendError(_t9 instanceof Error ? _t9 : new Error(String(_t9)), {
                          component: 'ApplyAllActionsPanel',
                          action: 'apply_single_action',
                          actionId: action.id
                        });
                      }
                    case 6:
                      return _context10.a(2);
                  }
                }, _callee0, null, [[0, 4]]);
              }));
              return function applyOneByOne(_x17) {
                return _ref21.apply(this, arguments);
              };
            }();
            appliedBeforeTheRun = new Set();
            if (!(runsAsOneRun && runIsLocal)) {
              _context12.n = 11;
              break;
            }
            runInsertionAnchors = new Set((0, _redlineInsertionSlot.insertionAnchorsOf)(bulk.remedies));
            _iterator12 = _createForOfIteratorHelper(orderedActions);
            _context12.p = 3;
            _iterator12.s();
          case 4:
            if ((_step12 = _iterator12.n()).done) {
              _context12.n = 8;
              break;
            }
            action = _step12.value;
            if (!(bulk.actionIds.has(action.id) || action.isApplied || !action.isSelected || action.isPartiallyApplied)) {
              _context12.n = 5;
              break;
            }
            return _context12.a(3, 7);
          case 5:
            paragraphCardAnchor = paragraphCardAnchorOf(messageMap.get(action.id));
            if (!(paragraphCardAnchor === null || !runInsertionAnchors.has(paragraphCardAnchor))) {
              _context12.n = 6;
              break;
            }
            return _context12.a(3, 7);
          case 6:
            appliedBeforeTheRun.add(action.id);
            _context12.n = 7;
            return applyOneByOne(action);
          case 7:
            _context12.n = 4;
            break;
          case 8:
            _context12.n = 10;
            break;
          case 9:
            _context12.p = 9;
            _t0 = _context12.v;
            _iterator12.e(_t0);
          case 10:
            _context12.p = 10;
            _iterator12.f();
            return _context12.f(10);
          case 11:
            if (!runsAsOneRun) {
              _context12.n = 19;
              break;
            }
            _context12.p = 12;
            if (!runIsLocal) {
              _context12.n = 13;
              break;
            }
            _t1 = {
              kind: "local",
              input: {
                remedies: bulk.remedies,
                comments: bulk.comments,
                readPageRange: (0, _liveReviewApply.readPagesFromOneDocumentRead)(),
                chooseConflictOptions: function chooseConflictOptions(paragraphs) {
                  return (0, _api.chooseConflictOptions)(authHeaderRef.current, paragraphs);
                },
                coveredSpansOver: function coveredSpansOver(bookmarkNames, pageOoxml) {
                  return _anchorTrackerRegistry.anchorTrackers.coveredSpansOver(bookmarkNames, pageOoxml);
                }
              }
            };
            _context12.n = 16;
            break;
          case 13:
            _t10 = _api.liveReviewBulkApply;
            _t11 = authHeaderRef.current;
            _t12 = conversationId;
            _t13 = "chat_apply_all_".concat(crypto.randomUUID());
            _t14 = bulk.remedies;
            _t15 = bulk.comments;
            _context12.n = 14;
            return (0, _document.getDocumentFileToBase64)();
          case 14:
            _context12.n = 15;
            return _t10(_t11, _t12, _t13, _t14, _t15, _context12.v);
          case 15:
            _t16 = _context12.v;
            _t17 = bulk.remedies;
            _t1 = {
              kind: "pipeline",
              statusFileUrl: _t16,
              remedies: _t17
            };
          case 16:
            source = _t1;
            bulkActionIds = new Set(bulk.actionIds);
            cardOutcomeOfTheRun = null;
            started = startRun({
              initiatedFrom: "chat_apply_all",
              reviewId: currentReviewId,
              rules: [].concat(_toConsumableArray(bulk.remedies), _toConsumableArray(bulk.comments)).map(function (entry) {
                return {
                  ruleId: entry.rule_uuid,
                  ruleName: entry.rule_name
                };
              }),
              source: source,
              onComplete: function onComplete(runOutcome) {
                var _changeThroughoutRunO = (0, _changeThroughoutRunOutcome.changeThroughoutRunOutcomeOf)(runOutcome, bulk.placeRulesByCardId),
                  outcome = _changeThroughoutRunO.cardOutcome,
                  placeOutcomesByCardId = _changeThroughoutRunO.placeOutcomesByCardId;
                cardOutcomeOfTheRun = outcome;
                recordPlaceOutcomes(placeOutcomesByCardId, messageMap);
                markCommentsTheRunRelocated(outcome, bulk.comments, cardCommentsRidingTheRun);
                settleBulkActionOutcomes(outcome, bulkActionIds, heldComments);
                markCardsWhoseCommentsWereNotWritten(outcome, bulk.comments);
                var writeCardCommentsAfterAPipelineRun = /*#__PURE__*/function () {
                  var _ref22 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
                    return _regenerator().w(function (_context11) {
                      while (1) switch (_context11.n) {
                        case 0:
                          if (!runIsLocal) {
                            _context11.n = 1;
                            break;
                          }
                          return _context11.a(2);
                        case 1:
                          _context11.n = 2;
                          return writeCommentsOfLandedCards(outcome.creditedRuleIds, function (actionId) {
                            return messageMap.get(actionId);
                          });
                        case 2:
                          return _context11.a(2);
                      }
                    }, _callee1);
                  }));
                  return function writeCardCommentsAfterAPipelineRun() {
                    return _ref22.apply(this, arguments);
                  };
                }();
                void writeCardCommentsAfterAPipelineRun().then(function () {
                  return releaseHeldComments(new Set([].concat(_toConsumableArray(outcome.creditedRuleIds), _toConsumableArray(sequentiallyAppliedIds))));
                }).finally(function () {
                  return setIsApplying(false);
                });
              },
              onStepsAfterTheRunSettled: function onStepsAfterTheRunSettled(finalTimeline) {
                if (cardOutcomeOfTheRun !== null) trackBulkApplyCompleted(cardOutcomeOfTheRun, finalTimeline);
              },
              onShowRule: showRunRule
            });
            if (started) {
              bulkStarted = true;
            } else {
              bulk.actionIds.clear();
              (0, _toast.toastError)(ANOTHER_RUN_IN_FLIGHT_MESSAGE);
            }
            _context12.n = 18;
            break;
          case 17:
            _context12.p = 17;
            _t18 = _context12.v;
            bulk.actionIds.clear();
            sendError(_t18 instanceof Error ? _t18 : new Error(String(_t18)), {
              component: 'ApplyAllActionsPanel',
              action: 'start_bulk_apply',
              conversationId: conversationId
            });
          case 18:
            _context12.n = 20;
            break;
          case 19:
            bulk.actionIds.clear();
          case 20:
            _iterator13 = _createForOfIteratorHelper(orderedActions);
            _context12.p = 21;
            _iterator13.s();
          case 22:
            if ((_step13 = _iterator13.n()).done) {
              _context12.n = 26;
              break;
            }
            _action = _step13.value;
            if (!(bulk.actionIds.has(_action.id) || appliedBeforeTheRun.has(_action.id))) {
              _context12.n = 23;
              break;
            }
            return _context12.a(3, 25);
          case 23:
            if (!(_action.isApplied || !_action.isSelected || _action.isPartiallyApplied)) {
              _context12.n = 24;
              break;
            }
            return _context12.a(3, 25);
          case 24:
            _context12.n = 25;
            return applyOneByOne(_action);
          case 25:
            _context12.n = 22;
            break;
          case 26:
            _context12.n = 28;
            break;
          case 27:
            _context12.p = 27;
            _t19 = _context12.v;
            _iterator13.e(_t19);
          case 28:
            _context12.p = 28;
            _iterator13.f();
            return _context12.f(28);
          case 29:
            if (bulkStarted) {
              _context12.n = 30;
              break;
            }
            _context12.n = 30;
            return releaseHeldComments(sequentiallyAppliedIds);
          case 30:
            _context12.n = 32;
            break;
          case 31:
            _context12.p = 31;
            _t20 = _context12.v;
            (0, _toast.toastError)(_t20);
            sendError(_t20 instanceof Error ? _t20 : new Error(String(_t20)), {
              component: 'ApplyAllActionsPanel',
              action: 'apply_all_actions',
              conversationId: conversationId
            });
          case 32:
            _context12.p = 32;
            if (!bulkStarted) {
              setIsApplying(false);
            }
            setRepairingActionId(null);
            return _context12.f(32);
          case 33:
            return _context12.a(2);
        }
      }, _callee10, null, [[21, 27, 28, 29], [12, 17], [3, 9, 10, 11], [1, 31, 32, 33]]);
    }));
    return function (_x16) {
      return _ref20.apply(this, arguments);
    };
  }(), [messages, conversationId, applyAction, freezeAppliedLooks, setLocalActions, onActionApplied, onActionRefused, onActionFailed, sendError, recordActionFailure, startRun, currentReviewId, settleBulkActionOutcomes, trackBulkApplyCompleted, markCommentsTheRunRelocated, markCardsWhoseCommentsWereNotWritten, writeCommentsOfLandedCards, showsProposalEngineTracker, trackerCards, conflictGroups, documentPage, applyHeldComments, readDocumentPageAgain]);
  var handleApplyAll = (0, _react.useCallback)(function () {
    return applyActions(localActions);
  }, [applyActions, localActions]);
  var handleApplyActions = (0, _react.useCallback)(function (actionIds) {
    var wantedIds = new Set(actionIds);
    return applyActions(localActions.filter(function (action) {
      return wantedIds.has(action.id) && action.heldBackReason === undefined;
    }).map(function (action) {
      return _objectSpread(_objectSpread({}, action), {}, {
        isSelected: true
      });
    }));
  }, [applyActions, localActions]);
  var handleDismissAll = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
    var selectedOpenActions;
    return _regenerator().w(function (_context13) {
      while (1) switch (_context13.n) {
        case 0:
          setIsDismissing(true);
          selectedOpenActions = localActions.filter(function (action) {
            return !action.isApplied && !action.isDismissed && action.isSelected;
          });
          _context13.n = 1;
          return Promise.allSettled(selectedOpenActions.map(function (action) {
            return onActionDismissed(action.id);
          }));
        case 1:
          setIsDismissing(false);
        case 2:
          return _context13.a(2);
      }
    }, _callee11);
  })), [localActions, onActionDismissed]);
  var selectedCount = unappliedUndismissedActions.filter(function (a) {
    return a.isSelected;
  }).length;
  function renderRowStatus(action) {
    if (action.isRefused) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_hoverTooltip.HoverTooltip, {
        content: "Not applied \u2014 this change would have altered the document without recording a tracked change. The assistant is redoing it.",
        align: "start",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: "flex items-center gap-1 flex-shrink-0 text-[#A81E36] font-medium",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
            width: 13,
            height: 13
          }), "Not applied"]
        })
      });
    }
    if (action.failureReason) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyFailedIndicator, {
        reason: action.failureReason
      });
    }
    if (action.rowRemovedBy !== undefined && !action.isApplied) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "flex items-center gap-1 flex-shrink-0 text-[#92400E] font-medium",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
          width: 13,
          height: 13
        }), (0, _redlineRowRemoved.rowRemovedLabelOf)(action.rowRemovedBy)]
      });
    }
    if (action.heldBackReason !== undefined && !action.isApplied) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "flex items-center gap-1 flex-shrink-0 text-[#92400E] font-medium",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
          width: 13,
          height: 13
        }), action.heldBackReason]
      });
    }
    return null;
  }
  var titleContent = isApplying ? repairingActionId ? 'Auto-repairing redline…' : 'Applying...' : isDismissing ? 'Dismissing...' : allApplied ? 'All Handled' : "".concat(selectedCount, " selected");
  var trackerTitle = conflictGroups.length > 0 && !isApplying && !isDismissing ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    children: [titleContent, " \xB7 ", /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "text-[#B45309]",
      children: [conflictGroups.length, " potential conflict", conflictGroups.length === 1 ? '' : 's']
    })]
  }) : titleContent;
  var applyAllLabel = showsProposalEngineTracker ? 'Apply selected' : 'Apply All';
  var dismissAllLabel = showsProposalEngineTracker ? 'Dismiss selected' : 'Dismiss All';
  var buttonText = isApplying ? 'Applying...' : allApplied ? 'All Handled' : applyAllLabel;
  var dismissButtonText = isDismissing ? 'Dismissing...' : dismissAllLabel;
  var proposalEngineTracker = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "h-full flex flex-col",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TrackerResizeHandle.TrackerResizeHandle, {
      height: shownTrackerHeight,
      maxHeight: maxTrackerHeight,
      defaultHeight: PROPOSAL_TRACKER_CONTENT_HEIGHT,
      onResize: setTrackerHeight
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex-1 min-h-0",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionBoundary.SectionBoundary, {
        section: "apply_all_list",
        cardActionIds: unappliedUndismissedActions.map(function (action) {
          return action.id;
        }),
        fallback: function fallback(reset) {
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-2 px-2 py-2 text-[11px] text-[#B45309]",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: APPLY_ALL_LIST_NOT_DRAWN_MESSAGE
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              type: "button",
              className: "underline",
              onClick: reset,
              children: "Try again"
            })]
          });
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProposalTracker.ProposalTracker, {
          actions: actionsWithDismissalSaving,
          trackerCards: trackerCards,
          conflictGroups: conflictGroups,
          conversationId: conversationId,
          authHeader: authHeader,
          isApplying: isApplying,
          allUnappliedSelected: allUnappliedSelected,
          onToggleSelection: onToggleSelection,
          onToggleSelectAll: onToggleSelectAll,
          onShowCard: function onShowCard(actionId) {
            return onActionClick === null || onActionClick === void 0 ? void 0 : onActionClick(actionId);
          },
          onGoTo: function onGoTo(bookmarks, actionIds) {
            return void handleGoTo(bookmarks, actionIds);
          },
          onLocateCard: function onLocateCard(card) {
            return void handleLocateCard(card);
          },
          onDismiss: onActionDismissed,
          onUndismiss: onActionUndismissed,
          onResolveOpened: handleResolveOpened,
          onApplyResolution: applyConflictResolution,
          onApplyActions: function onApplyActions(actionIds) {
            return void handleApplyActions(actionIds);
          },
          onEditCard: handleEditCard
        })
      })
    })]
  });
  var applyAllBlocked = isApplying || allApplied || !someUnappliedSelected || isDismissing || isAnyBulkRunActive;
  return {
    button: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        display: 'flex',
        gap: '6px',
        alignItems: 'center'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        onClick: handleApplyAll,
        disabled: applyAllBlocked,
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '3px',
          padding: '3px 12px',
          backgroundColor: applyAllBlocked ? '#B0B0B0' : 'var(--primary)',
          color: 'white',
          border: 'none',
          borderRadius: '3px',
          cursor: applyAllBlocked ? 'not-allowed' : 'pointer',
          fontSize: '11px',
          transition: 'all 0.2s',
          height: '22px',
          whiteSpace: 'nowrap',
          fontFamily: 'inherit'
        },
        children: [!isApplying && !allApplied && /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArrowBackIcon, {
          width: 16,
          height: 16
        }), buttonText]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        onClick: handleDismissAll,
        disabled: isDismissing || allApplied || !someUnappliedSelected || isApplying,
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '3px',
          padding: '3px 12px',
          backgroundColor: 'white',
          color: isDismissing || allApplied || !someUnappliedSelected || isApplying ? '#B0B0B0' : 'var(--primary)',
          border: "1px solid ".concat(isDismissing || allApplied || !someUnappliedSelected || isApplying ? '#B0B0B0' : 'var(--primary)'),
          borderRadius: '3px',
          cursor: isDismissing || allApplied || !someUnappliedSelected || isApplying ? 'not-allowed' : 'pointer',
          fontSize: '11px',
          transition: 'all 0.2s',
          height: '22px',
          whiteSpace: 'nowrap',
          fontFamily: 'inherit'
        },
        children: [dismissButtonText, !isDismissing && /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CloseIcon, {
          width: 14,
          height: 14
        })]
      })]
    }),
    title: showsProposalEngineTracker ? trackerTitle : titleContent,
    expandedContentHeight: showsProposalEngineTracker ? shownTrackerHeight : null,
    expandedContent: showsProposalEngineTracker ? proposalEngineTracker : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex flex-col gap-1.5",
      children: [unappliedUndismissedActions.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-2 px-2 py-1.5 border-b border-[#E5E2DD]",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          type: "checkbox",
          checked: allUnappliedSelected,
          onChange: onToggleSelectAll,
          className: "w-4 h-4 cursor-pointer accent-primary"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: "text-xs font-medium text-[#4a5568]",
          children: ["Select All (", unappliedUndismissedActions.length, ")"]
        })]
      }), unappliedUndismissedActions.map(function (action) {
        var _action$failureReason;
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          title: action.failureReason,
          className: "flex items-center gap-2 px-2 py-1.5 rounded text-xs transition-all ".concat(action.isRefused || action.failureReason ? 'bg-[#FDF2F4] border border-[#E3A3AE]' : 'bg-[#F8F6F3] border border-[#E5E2DD]'),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
            type: "checkbox",
            checked: action.isSelected,
            disabled: action.isPartiallyApplied || action.documentAlreadyReadsAsProposed || action.heldBackReason !== undefined,
            onChange: function onChange(e) {
              e.stopPropagation();
              onToggleSelection(action.id);
            },
            className: "w-4 h-4 cursor-pointer accent-primary flex-shrink-0 disabled:cursor-not-allowed disabled:opacity-50"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            className: "font-medium capitalize text-[#4a5568] min-w-[60px]",
            children: [action.type, " #", action.cardNumber]
          }), renderRowStatus(action), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            type: "button",
            onClick: function onClick() {
              return onActionClick === null || onActionClick === void 0 ? void 0 : onActionClick(action.id);
            },
            className: "flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-[#686766] cursor-pointer hover:text-[#4a5568] bg-transparent border-none p-0 text-left",
            title: (_action$failureReason = action.failureReason) !== null && _action$failureReason !== void 0 ? _action$failureReason : action.description,
            children: action.description
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: function onClick(e) {
              e.stopPropagation();
              onActionDismissed(action.id);
            },
            disabled: action.isDismissalSaving,
            "aria-busy": action.isDismissalSaving || undefined,
            className: "flex-shrink-0 p-1 hover:bg-[#E5E2DD] rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
            title: "Dismiss",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyIconOrSpinner, {
              isSaving: Boolean(action.isDismissalSaving),
              icon: _materialSymbols.CloseIcon,
              size: 14,
              className: "text-[#686766]"
            })
          })]
        }, action.id);
      }), localActions.filter(function (a) {
        return a.isApplied;
      }).map(function (action) {
        var warning = getActionRecoveryWarning(conversationId, action.id);
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex items-center gap-2 px-2 py-1.5 rounded text-xs transition-all border ".concat(warning ? 'bg-[#FFFBEB] border-[#FDE68A]' : 'bg-[#F0F9FF] border-[#B3D9FF]'),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
            width: 16,
            height: 16,
            className: "text-primary flex-shrink-0"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            className: "font-medium capitalize text-[#4a5568] min-w-[60px]",
            children: [action.type, " #", action.cardNumber]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            type: "button",
            onClick: function onClick() {
              return onActionClick === null || onActionClick === void 0 ? void 0 : onActionClick(action.id);
            },
            className: "flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-[#686766] cursor-pointer hover:text-[#4a5568] bg-transparent border-none p-0 text-left",
            title: action.description,
            children: action.description
          }), warning && /*#__PURE__*/(0, _jsxRuntime.jsx)(_hoverTooltip.HoverTooltip, {
            content: warning,
            align: "start",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "flex-shrink-0 inline-flex items-center cursor-help text-[#F59E0B]",
              "aria-label": "Recovery warning",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
                width: 14,
                height: 14
              })
            })
          })]
        }, action.id);
      }), dismissedActions.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "border-t border-[#E5E2DD] mt-2 pt-2",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "text-xs font-medium text-[#686766] px-2 mb-1",
          children: ["Dismissed (", dismissedActions.length, ")"]
        }), dismissedActions.map(function (action) {
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-2 px-2 py-1.5 rounded text-xs transition-all bg-[#F5F5F5] border border-[#D4D3D0] opacity-60",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CloseIcon, {
              width: 14,
              height: 14,
              className: "text-[#686766] flex-shrink-0"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              className: "font-medium capitalize text-[#686766] min-w-[60px]",
              children: [action.type, " #", action.cardNumber]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-[#686766]",
              children: action.description
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              onClick: function onClick(e) {
                e.stopPropagation();
                onActionUndismissed(action.id);
              },
              disabled: action.isDismissalSaving,
              "aria-busy": action.isDismissalSaving || undefined,
              className: "flex-shrink-0 p-1 hover:bg-[#E5E2DD] rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
              title: "Undo dismiss",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyIconOrSpinner, {
                isSaving: Boolean(action.isDismissalSaving),
                icon: _materialSymbols.UndoIcon,
                size: 14,
                className: "text-[#686766]"
              })
            })]
          }, action.id);
        })]
      })]
    })
  };
};